import React, { useState, useEffect } from "react";
import { Alert, Form, Row, Col, Button, FormFeedback, FormGroup, Label, Input, UncontrolledPopover, PopoverBody } from "reactstrap";
import { Link } from "react-router-dom";
import ConfigData from '../../../config.json';
import axios from "axios";
import Swal from "sweetalert2";
import Select from "react-select";
import { useFormik } from "formik";
import { useHistory } from "react-router-dom";
import * as Yup from "yup";
import SingleUploadfile from '../../common/single-uploadfile';
import MultipleUploadfile from '../../common/multiple-uploadfile';
import { getFilterOldFileName, setFormDataUploadFile, setStringFileNameToArray, setShowFileName  } from '../../utils/format-value';
// import { setSelectionRange } from "@testing-library/user-event/dist/utils";
import { IconAlertError, IconAlertReturn } from '../../../components/common/popup-alert';
import { getDomain } from '../../utils/check-value';

const RequestFormGct = ({ dataFormGct, dataFormRequest, onSaveDraft, onSave, onCancelRequest}) => {
    const history = useHistory();
    const [formTemp, setFormTemp] = useState({});
    const [dataDetail, setDataDetail] = useState([]);
    const [selectReqLegalTeamTo, setSelectReqLegalTeamTo] = useState(null);
    const [selectBU, setSelectBU] = useState(null);
    const [dataUser, setDataUser] = useState([]);
    const [emailLegalAdmin , setEmailLegalAdmin] = useState([]);
    const [paymentTerm, setPaymentTerm] = useState("");
    const [dataLanguage, setDataLanguage] = useState([]);
    const [selectLanguage, setSelectLanguage] = useState(null);
    const [dataConfidential, setDataConfidential] = useState([]);
    const [selectConfidential, setSelectConfidential] = useState(null);
    const [dataCompany, setDataCompany] = useState([]);
    const [selectCompany, setSelectCompany] = useState(null);
    const [sharePdpa, setSharePdpa] = useState("");
    const [fileReqLegalTeamToDoc, setFileReqLegalTeamToDoc] = useState([]);
    const [filenameReqLegalTeamToDoc, setFilenameReqLegalTeamToDoc] = useState("");
    const [fileCounterpartyDoc, setFileCounterpartyDoc] = useState([]);
    const [fileDetailContractDoc, setFileDetailContractDoc] = useState([]);
    const [ddlReqLegalTeamTo, setDdlReqLegalTeamTo] = useState([]);
    const [ddlBU, setDdlBU] = useState([]);
    const [ddlLanguage, setDdlLanguage] = useState([]);
    const [ddlConfidential, setDdlConfidential] = useState([]);
    const [isCheckedCompanyOther, setIsCheckedCompanyOther] = useState(false);
    const [companyDisabled, setCompanyDisabled] = useState(false);
    const [otherCompanyDisabled, setOtherCompanyDisabled] = useState(true);
    const [paymentTermDisabled1, setPaymentTermDisabled1] = useState(true);
    const [paymentTermDisabled2, setPaymentTermDisabled2] = useState(true);
    const [companyPlaceholder, setCompanyPlaceholder] = useState("ระบุชื่อในการทำสัญญา");
    const [otherCompanyPlaceholder, setOtherCompanyPlaceholder] = useState("");
    const [showCommentApprover, setShowCommentApprover] = useState(false);
    const [isSaveEnabled, setIsSaveEnabled] = useState(false);
    const [isDisableds, setIsDisableds] = useState(false);
    const [AttachDraft, setAttachDraft] = useState(false);
    const [emailLegalAuthorized , setEmailLegalAuthorized] = useState([]);
    const [selectCompanyActAs, setSelectCompanyActAs] = useState(null);
    const [ddlCompanyActAs, setDdlCompanyActAs] = useState([]);
    const [selectCounterActAs, setSelectCounterActAs] = useState(null);
    const [ddlCounterActAs, setDdlCounterActAs] = useState([]);

    const handleCheckboxChangeCompanyOther = () => {
        const isChecked = !isCheckedCompanyOther; // Toggle the state
        setIsCheckedCompanyOther(isChecked);
    
        // Update states based on checkbox status
        setCompanyDisabled(isChecked);
        setOtherCompanyDisabled(!isChecked);
        setCompanyPlaceholder(isChecked ? "" : "โปรดเลือก...");
        setOtherCompanyPlaceholder(isChecked ? "กรอกชื่อบริษัท" : "");
        setSelectBU("");
    
        // Reset form fields
        resetValidationFields(isChecked);
    };
    
    // Utility function to reset validation fields
    const resetValidationFields = (isChecked) => {
        validation.setFieldValue("id_business_unit", isChecked ? "-1" : "");
        validation.setFieldValue("business_unit_other", "");
        validation.setFieldError("id_business_unit", null);
        validation.setFieldError("business_unit_other", null);
        validation.setFieldTouched("id_business_unit", false);
        validation.setFieldTouched("business_unit_other", false);
    };

    const userEmail = (!localStorage.getItem("emd")) ? "" : atob(localStorage.getItem("emd"));
    const autoCompletes = "on";
    const englishEmailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    // Thailand is UTC+7
    const thaiTimezoneOffset = 7 * 60; 
    const offsetInMilliseconds = thaiTimezoneOffset * 60 * 1000;
    const thaiDateTime = new Date(new Date().getTime() + offsetInMilliseconds);
    // Format the date for MySQL DATETIME
    const newDateTime = thaiDateTime.toISOString().slice(0, 19).replace("T", " ");

    const optionDdlReqLegalTeamTo = [
        { value: "1", label: "ตรวจสอบสัญญา/บันทึกข้อตกลงตามแนบ (Review draft agreement as attached)" },
        { value: "2", label: "ให้ฝ่ายกฎหมายจัดทำสัญญา/บันทึกข้อตกลง (Draft agreement)" },
    ];
    const optionDdlCompanyActAs = [
        { value: "1", label: "ผู้รับจ้าง (Service Provider)" },
        { value: "2", label: "ผู้ว่าจ้าง (Service Receiver)" },
    ];
    const optionDdlCounterActAs = [
        { value: "1", label: "ผู้รับจ้าง (Service Provider)" },
        { value: "2", label: "ผู้ว่าจ้าง (Service Receiver)" },
    ];
    
    useEffect(() => {
        LoadDataBusinessUnit();
        LoadDataLanguage();
        LoadDataConfidential();
        LoadProfileUser(userEmail);
        LoadLegalAdmin(5); // หมายถึง กลุ่มของ user admin
        setDdlReqLegalTeamTo(optionDdlReqLegalTeamTo);
        setDdlCompanyActAs(optionDdlCompanyActAs);
        setDdlCounterActAs(optionDdlCounterActAs);
    }, []);

    useEffect(() => {
        if(dataFormGct.id > 0){
            let updateddataFormGct = {...dataFormGct};

            if (dataFormRequest.request_no === "draft" && dataFormRequest.id_business_unit === "-1") {
                updateddataFormGct.id_business_unit = "";
            }
            if (dataFormRequest.id_confidential_level === "0") {
                updateddataFormGct.id_confidential_level = "";
            }
            // console.log(updateddataFormGct);
            setDataDetail(updateddataFormGct);
            setFileReqLegalTeamToDoc(dataFormGct.req_legal_team_to_doc ? setStringFileNameToArray(dataFormGct.req_legal_team_to_doc) : []);
            setFileCounterpartyDoc(dataFormGct.counterparty_doc ? setStringFileNameToArray(dataFormGct.counterparty_doc) : []);
            setFileDetailContractDoc(dataFormGct.detail_contract_doc ? setStringFileNameToArray(dataFormGct.detail_contract_doc) : []);
            setSharePdpa(dataFormGct.share_pdpa ?? "");
            setPaymentTerm(dataFormGct.payment_term ?? "");
            if(dataFormGct.payment_term === "1"){
                setPaymentTermDisabled1(false);
            } else {
                setPaymentTermDisabled2(false);
            }
            
            if(dataFormRequest.request_no !== "draft" && dataFormGct.approver_comment !== ""){
                setShowCommentApprover(true);
            }
            LoadFormTempById(dataFormRequest.id_form_temp);
        }
    }, [dataFormGct, dataFormRequest]);

    useEffect(() => {
        if(dataFormGct.id > 0){
            // 1. set group requestor can edit when id workflow = 4 or draft or user groupId2 when user can approve request.
            // 2,3. set group approver can edit when id workflow = 1,2
            if( (checkLoadDataRequestAndForm) ){
                setCompanyDisabled(false);
                // setBeginningDateDisabled(
                //     (dataFormGct.beginning_date && dataFormGct.beginning_date.length > 0) ? false :
                //     (selectedTerm !== "1" && (dataFormRequest.request_no === "draft" || dataFormGct.beginning_date === null) ) ? true : false
                // );
            } else if( dataFormRequest.id_workflow_status > 4 ){
                setIsDisableds(false);
                setCompanyDisabled(false);
                // setBeginningDateDisabled(
                //     (dataFormGct.beginning_date && dataFormGct.beginning_date.length > 0) ? false :
                //     (selectedTerm !== "1" && (dataFormRequest.request_no === "draft" || dataFormGct.beginning_date === null) ) ? true : false
                // );
            } else {
                setIsDisableds(true);
                setCompanyDisabled(true);
                // setBeginningDateDisabled(true);
            }
            setSelectLanguage(ddlLanguage.find(x => x.value === dataFormGct.id_language?.toString()) ?? "");
            setSelectConfidential(ddlConfidential.find(x => x.value === dataFormGct.id_confidential_level?.toString()) ?? "");
            setSelectBU(ddlBU.find(x => x.value === dataFormGct.id_business_unit?.toString()) ?? "");
            setSelectCompanyActAs(ddlCompanyActAs.find(x => x.value === dataFormGct.business_unit_act_as?.toString()) ?? "");
            setSelectCounterActAs(ddlCounterActAs.find(x => x.value === dataFormGct.counterparty_act_as?.toString()) ?? "");
            setSelectReqLegalTeamTo(ddlReqLegalTeamTo.find(x => x.value === dataFormGct.req_legal_team_to?.toString()) ?? "")
            LoadLegalAuthorized(dataFormGct.id_business_unit);
        }
    }, [ddlLanguage, ddlConfidential, ddlBU, dataFormGct ]);

    const LoadLegalAdmin = (groupId) => {
        let url = ConfigData.API_URL + "user/?status=1&id_user_group=" + groupId;
        let token = "Bearer " + localStorage.getItem("tkd");
        axios.get(url, {
            headers: {
                "Content-Type": "application/json",
                Authorization: token,
            },
            responseType: "json",
        })
        .then((resp) => {
            const respData = resp.data;
            if (respData.is_sucess && respData.data.length > 0) {
                setEmailLegalAdmin(respData.data);
            }
        }).catch((error) => {
            console.log(error);
        });
    };

    const LoadLegalAuthorized = (idBusinessUnit) => {
        let url = ConfigData.API_URL + "map-user-assign/search?status=1&id_business_unit=" + idBusinessUnit;
        let token = "Bearer " + localStorage.getItem("tkd");
        axios.get(url, { headers: { 
            'Authorization' : token ,
        }, responseType: "json" })
        .then(resp => {
            let respData = resp.data;
            if(respData.is_sucess === true && respData.data.length > 0){
                setEmailLegalAuthorized(respData.data);
                // console.log(respData.data[0].email);
            } else {
                setEmailLegalAuthorized("");
            }
        })
        .catch(error => {
            // handlerRespError(error, history);
            console.log(error);
        });
    };

    const LoadFormTempById = (idFormTemp) =>{
        let url = ConfigData.API_URL + "form-temp/" + idFormTemp;
        let token = "Bearer " + localStorage.getItem("tkd");
        axios.get(url, { headers: { 
            'Authorization' : token ,
        }, responseType: "json" })
        .then(resp => {
            let respData = resp.data;
            if(respData.is_sucess === true && respData.data.length > 0){
                setFormTemp(respData.data[0]);
            }
        })
        .catch(error => {
            // handlerRespError(error, history);
            console.log(error);
        });
    };

    const LoadProfileUser = (email) => {
        let url = ConfigData.API_URL + "user/search?status=1&email=" + email;
        let token = "Bearer " + localStorage.getItem("tkd");
        axios.get(url, { headers: { 
            'Authorization' : token ,
        }, responseType: "json" })
        .then(resp => {
            let respData = resp.data;
            if(respData.is_sucess === true && respData.data.length > 0){
                setDataUser(respData.data[0]);
            }
        })
        .catch(error => {
            // handlerRespError(error, history);
            console.log(error);
        });
    };

    const LoadDataBusinessUnit = () => {
        let url = ConfigData.API_URL + "business-unit/search?status=1";
        let token = "Bearer " + localStorage.getItem("tkd");
        axios.get(url, { headers: { 
            'Authorization' : token ,
        }, responseType: "json" })
        .then(resp => {
            let respData = resp.data;
            if(respData.is_sucess === true){
                const arrData = respData.data.map((e) => {
                    return {
                        label: e.name_en,
                        value: e.id.toString()
                    };
                });
                setDdlBU(arrData);
            }
        })
        .catch(error => {
            // handlerRespError(error, history);
            console.log(error);
        });
    };

    const LoadDataLanguage = () => {
        let url = ConfigData.API_URL + "language/?status=1";
        let token = "Bearer " + localStorage.getItem("tkd");
        axios.get(url, { headers: { 
            'Authorization' : token ,
        }, responseType: "json" })
        .then(resp => {
            let respData = resp.data;
            if(respData.is_sucess === true){
                const arrData = respData.data.map((e) => {
                    return {
                        label: e.name,
                        value: e.id.toString(),
                    };
                });
                setDdlLanguage(arrData);
            }
        })
        .catch(error => {
            // handlerRespError(error, history);
            console.log(error);
        });
    };

    const LoadDataConfidential= () => {
        let url = ConfigData.API_URL + "confidential/?status=1";
        let token = "Bearer " + localStorage.getItem("tkd");
        axios.get(url, { headers: { 
            'Authorization' : token ,
        }, responseType: "json" })
        .then(resp => {
            let respData = resp.data;
            if(respData.is_sucess === true){
                const arrData = respData.data.map((e) => {
                    return {
                        label: e.name_th + " (" + e.name_en + ")",
                        value: e.id.toString(),
                    };
                });
                setDdlConfidential(arrData);
            }
        })
        .catch(error => {
            // handlerRespError(error, history);
            console.log(error);
        });
    };

    const validation = useFormik({
        enableReinitialize: true,
        initialValues: {
            id: dataDetail.id || 0,
            project_name: dataDetail.project_name || "",
            req_legal_team_to: dataDetail.req_legal_team_to || "",
            req_legal_team_to_doc: dataDetail.req_legal_team_to_doc || "",
            id_business_unit: dataDetail.id_business_unit || "",
            business_unit_other: dataDetail.business_unit_other || "",
            business_unit_act_as: dataDetail.business_unit_act_as || "",
            counterparty_name: dataDetail.counterparty_name || "",
            counterparty_doc: dataDetail.counterparty_doc || "",
            counterparty_act_as: dataDetail.counterparty_act_as || "",
            purpose: dataDetail.purpose || "",
            place_of_performance: dataDetail.place_of_performance || "",
            responsibilities_each_party: dataDetail.responsibilities_each_party || "",
            detail_contract_doc: dataDetail.detail_contract_doc || "",
            term_start_date: dataDetail.term_start_date || "",
            term_end_date: dataDetail.term_end_date || "",
            renewal_term: dataDetail.renewal_term || "",
            rate_of_price: dataDetail.rate_of_price || "",
            payment_term: dataDetail.payment_term || "",
            payment_term_desc_lump_sum: dataDetail.payment_term_desc_lump_sum || "",
            payment_term_desc_instalment: dataDetail.payment_term_desc_instalment || "",
            penalty: dataDetail.penalty || "",
            termination: dataDetail.termination || "",
            is_stamp_duty: dataDetail.is_stamp_duty || "",
            stamp_duty_price: dataDetail.stamp_duty_price || "",
            other_fee: dataDetail.other_fee || "",
            other_special_clause: dataDetail.other_special_clause || "",
            id_language: dataDetail.id_language || "",
            share_pdpa: dataDetail.share_pdpa || "",
            user_comment: dataDetail.user_comment || "",
            id_confidential_level: dataDetail.id_confidential_level || "",
            check_request_no: dataFormRequest?.request_no || "",
            require_handled_by: dataFormRequest?.require_handled_by || dataDetail?.require_handled_by || "",
            approve_request_by: dataFormRequest?.approve_request_by || dataDetail?.approve_request_by || "",
            approver_comment: dataFormRequest?.approver_comment || dataDetail?.approver_comment || "",
            create_request_by: dataFormRequest?.create_request_by || dataDetail?.create_request_by || "",
            check_user_email: dataFormRequest?.create_request_by || dataDetail?.create_request_by || userEmail,
        },
        validationSchema: Yup.object({
            //project_name: Yup.string().required("กรุณาเลือก/Please select"),
            req_legal_team_to: Yup.string().required("กรุณาเลือก/Please select"),
            id_business_unit: Yup.string().when("isDisabled", {
                            is: (isDisabled) => !isDisabled,
                            then: Yup.string().required("กรุณาเลือก/Please select"),
                            otherwise: Yup.string().notRequired(),
                        }),
            business_unit_other: Yup.string().when(["id_business_unit", "isDisabled"], {
                is: (id_business_unit, isDisabled) => !isDisabled && id_business_unit === "-1",
                then: Yup.string().trim().required("กรุณากรอกข้อมูล/Please fill out"),
                otherwise: Yup.string().notRequired(),
            }),
            business_unit_act_as: Yup.string().required("กรุณาเลือก/Please select"),
            counterparty_name: Yup.string().required("กรุณากรอกข้อมูล/Please fill out"),
            counterparty_act_as: Yup.string().required("กรุณาเลือก/Please select"),
            purpose: Yup.string().required("กรุณากรอกข้อมูล/Please fill out"),
            place_of_performance: Yup.string().required("กรุณากรอกข้อมูล/Please fill out"),
            responsibilities_each_party: Yup.string().required("กรุณากรอกข้อมูล/Please fill out"),
            detail_contract_doc: Yup.string().required("กรุณาแนบไฟล์/Please attachment file"),
            term_start_date: Yup.string().required("กรุณาเลือก/Please select"),
            stamp_duty_price: Yup.string().required("กรุณากรอกข้อมูล/Please fill out"),
            term_end_date: Yup.string().required("กรุณาเลือก/Please select"),
            rate_of_price: Yup.string().required("กรุณากรอกข้อมูล/Please fill out"),
            id_language: Yup.string().required("กรุณาเลือก/Please select"),
            payment_term: Yup.string().required("กรุณาเลือก/Please select"),
            id_confidential_level: Yup.string().required("กรุณาเลือก/Please select"),
            share_pdpa: Yup.string().required("กรุณาเลือก/Please select"),
            user_comment: Yup.string().required("กรุณากรอกข้อมูล/Please fill out"),
            approve_request_by: Yup.string().when("check_request_no", {
                is: (check_request_no) => check_request_no === undefined || check_request_no === "draft",
                then: Yup.string().required("กรุณาระบุอีเมลผู้อนุมัติ/Please provide the approver's email address")
                .email("กรุณาระบุอีเมลผู้อนุมัติ/Please provide the approver's email address").matches(englishEmailRegex, "Email must be a valid English email address")
                .test('is-not-current-user', 'ไม่สามารถใช้อีเมลของผู้ใช้งานปัจจุบัน/You cannot use your own email', function(value) {
                    return value?.toLowerCase() !== userEmail; 
                }),
                otherwise: Yup.string().required("กรุณาระบุอีเมลผู้อนุมัติ/Please provide the approver's email address")
                .email("กรุณาระบุอีเมลผู้อนุมัติ/Please provide the approver's email address").matches(englishEmailRegex, "Email must be a valid English email address"),
            }),
            create_request_by: Yup.string().when("check_user_email", {
                is: (check_user_email) => getDomain(check_user_email) === "rabbitholdings.co.th" || dataUser.business_unit?.toLowerCase() === "rabbit holdings public company limited",
                then: Yup.string().required("กรุณาระบุอีเมลผู้ประสานงาน/Please provide the coordinator's email address")
                .email("กรุณาระบุอีเมลผู้ประสานงาน/Please provide the coordinator's email address")
                .matches(englishEmailRegex, "Email must be a valid English email address"),
                otherwise: Yup.string().nullable(),
            }),
        }),
        onSubmit: (values) => {
            //console.log(values);
            values.id_workflow_status = dataFormRequest.id_workflow_status;
            values.id_language = values.id_language !== "" ? parseInt(values.id_language) : null;
            values.id_confidential_level = String(values.id_confidential_level);
            values.request_no = dataFormRequest.request_no; // check request_no
            values.file_req_legal_team_to_doc = fileReqLegalTeamToDoc;
            // values.file_consider_doc = fileConsiderDoc;
            values.file_counterparty_doc = fileCounterpartyDoc;
            values.file_detail_contract_doc = fileDetailContractDoc;
            values.id_business_unit = companyDisabled === true ? "-1" : values.id_business_unit;
            values.business_unit_other = otherCompanyDisabled === true ? "" : values.business_unit_other;
            values.legal_authorized = emailLegalAuthorized;
            values.legal_admin = emailLegalAdmin;
            values.approve_request_by = values.approve_request_by?.toLowerCase();
            values.require_handled_by = values.require_handled_by?.toLowerCase();
            values.create_request_by = values.create_request_by?.toLowerCase();
            //console.log(values);
            onSave(values)
        }
    });

    const validationDraft = useFormik({
        enableReinitialize: true,
        initialValues: {
            id: dataDetail.id || 0,
            project_name: dataDetail.project_name || "",
            req_legal_team_to: dataDetail.req_legal_team_to || "",
            req_legal_team_to_doc: dataDetail.req_legal_team_to_doc || "",
            id_business_unit: dataDetail.id_business_unit || "",
            business_unit_other: dataDetail.business_unit_other || "",
            business_unit_act_as: dataDetail.business_unit_act_as || "",
            counterparty_name: dataDetail.counterparty_name || "",
            counterparty_doc: dataDetail.counterparty_doc || "",
            counterparty_act_as: dataDetail.counterparty_act_as || "",
            purpose: dataDetail.purpose || "",
            place_of_performance: dataDetail.place_of_performance || "",
            responsibilities_each_party: dataDetail.responsibilities_each_party || "",
            detail_contract_doc: dataDetail.detail_contract_doc || "",
            term_start_date: dataDetail.term_start_date || "",
            term_end_date: dataDetail.term_end_date || "",
            renewal_term: dataDetail.renewal_term || "",
            rate_of_price: dataDetail.rate_of_price || "",
            payment_term: dataDetail.payment_term || "",
            payment_term_desc_lump_sum: dataDetail.payment_term_desc_lump_sum || "",
            payment_term_desc_instalment: dataDetail.payment_term_desc_instalment || "",
            penalty: dataDetail.penalty || "",
            termination: dataDetail.termination || "",
            is_stamp_duty: dataDetail.is_stamp_duty || "",
            stamp_duty_price: dataDetail.stamp_duty_price || "",
            other_fee: dataDetail.other_fee || "",
            other_special_clause: dataDetail.other_special_clause || "",
            id_language: dataDetail.id_language || "",
            share_pdpa: dataDetail.share_pdpa || "",
            user_comment: dataDetail.user_comment || "",
            id_confidential_level: dataDetail.id_confidential_level || "",
            check_request_no: dataFormRequest?.request_no || "",
            require_handled_by: dataFormRequest?.require_handled_by || dataDetail?.require_handled_by || "",
            approve_request_by: dataFormRequest?.approve_request_by || dataDetail?.approve_request_by || "",
            approver_comment: dataFormRequest?.approver_comment || dataDetail?.approver_comment || "",
            create_request_by: dataFormRequest?.create_request_by || dataDetail?.create_request_by || "",
            check_user_email: dataFormRequest?.create_request_by || dataDetail?.create_request_by || userEmail,
        },
        onSubmit: (values) => {
            values.id_workflow_status = dataFormRequest.id_workflow_status;
            values.id_language = values.id_language !== "" ? parseInt(values.id_language) : null;
            values.request_no = dataFormRequest.request_no; // check request_no
            values.file_req_legal_team_to_doc = fileReqLegalTeamToDoc;
            values.id_confidential_level = String(values.id_confidential_level);
            // values.file_consider_doc = fileConsiderDoc;
            values.file_counterparty_doc = fileCounterpartyDoc;
            values.file_detail_contract_doc = fileDetailContractDoc;
            values.id_business_unit = companyDisabled === true ? "-1" : (values.id_business_unit !== "") ? parseInt(values.id_business_unit) : 0;
            // values.id_business_unit = companyDisabled === true ? "-1" : values.id_business_unit;
            values.stamp_duty_price = values.stamp_duty_price !== "" ? values.stamp_duty_price : null;
            values.business_unit_other = otherCompanyDisabled === true ? "" : values.business_unit_other;
            if(dataFormRequest?.request_no === undefined || dataFormRequest?.request_no === "draft"){
                values.approve_request_by = values.approve_request_by?.toLowerCase() === userEmail.toLowerCase() ? "" : values.approve_request_by?.toLowerCase();
            } else {
                values.approve_request_by = values.approve_request_by?.toLowerCase();
            }
            values.require_handled_by = values.require_handled_by?.toLowerCase();
            values.create_request_by = values.create_request_by?.toLowerCase();
            // console.log(values);
            onSaveDraft(values)
        }
    });

    const validationReturn = useFormik({
        enableReinitialize: true,
        initialValues: {
            approver_comment: dataFormRequest?.approver_comment || dataDetail?.approver_comment || "",
        },
        validationSchema: Yup.object({
            // approver_comment: Yup.string().when('showCommentApprover', {
            //     is: false,
            //     then: Yup.string().required('Please enter a Comment.'),
            //     otherwise: Yup.string(),
            // }),
            approver_comment: Yup.string().trim().required("กรุณาระบุความเห็นเพิ่มเติม"),
        }),
        onSubmit: (values) => {
            // console.log(values);
        }
    });

    const GetUrlBack = () => {
        const urlBack = (dataFormRequest.table_name !== "" && dataFormRequest.table_name !== null && dataFormRequest.table_name !== undefined) ? "/request-form/" + btoa(dataFormRequest.table_name) : "/all-type-request";
        return urlBack;
    };

    const OnSetFileReqLegalTeamToDoc = (files) => {
        const fileName = (files.length > 0) ? files[0].name : "";
        setFileReqLegalTeamToDoc(files);
        validation.handleChange('req_legal_team_to_doc')(fileName);
        validationDraft.handleChange('req_legal_team_to_doc')(fileName);
        setIsSaveEnabled(true);
    };

    const OnSetFileCounterpartyDoc = (files) => {
        const fileName = (files.length > 0) ? files[0].name : "";
        setFileCounterpartyDoc(files);
        validation.handleChange('counterparty_doc')(fileName);
        validationDraft.handleChange('counterparty_doc')(fileName);
        setIsSaveEnabled(true);
    };

    const OnSetFileDetailContractDoc = (files) => {
        const fileName = (files.length > 0) ? files[0].name : "";
        setFileDetailContractDoc(files);
        validation.handleChange('detail_contract_doc')(fileName);
        validationDraft.handleChange('detail_contract_doc')(fileName);
        setIsSaveEnabled(true);
    };

    const checkAuthorizedSubmitOrApprove = (
        (dataUser.email === dataFormRequest.approve_request_by && dataUser.email !== dataFormRequest.request_by) 
        || (dataFormRequest.request_by === dataFormRequest.approve_request_by && dataUser.id_user_group === 2) 
        || dataFormRequest.id_workflow_status === 4
    );

    const checkUserIsApproverShowReturnBtn = (
        dataUser.email === dataFormRequest.approve_request_by && dataFormRequest.id_workflow_status !== 4
    );

    // case if requestor && approver ถ้าคนเปิด request และ คนอนุมัติเป็นคนเดียวกันจะปิด ปุ่ม return ถ้าใช้
    const checkUserCreateTicketAndApproveIsSame = ( 
        dataFormRequest.request_by !== dataFormRequest.approve_request_by
    );

    const checkAuthorizedReturn = (
        (dataUser.email === dataFormRequest.approve_request_by && dataUser.email !== dataFormRequest.request_by) 
        || (dataUser.id_user_group === 2) 
        || (dataFormRequest.id_workflow_status === 4)
    );

    const changeButtonIsStateRequestorOrApprover = (
        (dataFormRequest.id_workflow_status !== 1 && dataFormRequest.id_workflow_status !== 2 && dataUser.email === dataFormRequest.request_by) 
        || (dataFormRequest.id_workflow_status !== 4 && dataUser.email === dataFormRequest.approve_request_by) 
        || (dataFormGct.id === 0)
    );

    const checkShowInputUserCoordinator = (
        (getDomain(userEmail) === "rabbitholdings.co.th" || dataUser.business_unit?.toLowerCase() === "rabbit holdings public company limited") 
        && (dataFormGct.id === 0 || dataFormRequest.request_no === "draft")
    );

    const checkLoadDataRequestAndForm = (
        (dataFormRequest.id_workflow_status === 4 && userEmail === dataFormRequest.create_request_by || dataFormRequest.id_workflow_status === 0) 
        || (dataFormRequest.id_workflow_status === 4 && userEmail === dataFormRequest.request_by || dataFormRequest.id_workflow_status === 0)
        || (dataFormRequest.request_by === dataFormRequest.approve_request_by && dataUser.id_user_group === 2) 
        || (dataFormRequest.id_workflow_status === 1 && userEmail === dataFormRequest.approve_request_by) 
        || (dataFormRequest.id_workflow_status === 2 && userEmail === dataFormRequest.approve_request_by)
    );

    const onCheckSaveDraft = () => {
        dataUser.email === dataFormRequest.approve_request_by ? setIsSaveEnabled(false) : setIsSaveEnabled(true);
        if(( dataUser.email === dataFormRequest.approve_request_by && dataUser.email !== dataFormRequest.request_by ) || (dataFormRequest.request_by === dataFormRequest.approve_request_by && dataUser.id_user_group === 2) || dataFormRequest.id_workflow_status === 4 || dataFormRequest.id_workflow_status === 0){
            validationDraft.submitForm();
        } else if(dataFormGct.id_request === ""){
            validationDraft.submitForm();
        } else {
            Swal.fire({
                iconHtml: IconAlertError,
                title: "You Are not authorized to action this1.",
                showConfirmButton: false,
                showCloseButton: true,
            });
        }
    }

    const onCheckSubmit = async () => {
        // ทำการ validate ฟอร์มทั้งหมด
        const errors = await validation.validateForm();
    
        // ตรวจสอบว่ามี error หรือไม่
        if (Object.keys(errors).length > 0) {
            Swal.fire({
                iconHtml: IconAlertError,
                title: "กรุณากรอกข้อมูลให้ครบถ้วน",
                showConfirmButton: false,
                showCloseButton: true,
            });
            // return; // หยุดการทำงานถ้ามี error
        }
    
        // ถ้าไม่มี error ให้ทำการ submit form
        if (!dataFormRequest.id_workflow_status) {
            validation.submitForm();
        } else if ( checkAuthorizedSubmitOrApprove ) {
            validation.submitForm();
        } else {
            Swal.fire({
                iconHtml: IconAlertError,
                title: "You Are not authorized to action this.",
                showConfirmButton: false,
                showCloseButton: true,
            });
        }
    
        // ตรวจสอบค่าของ validation
        // console.log(validation);
    };

    const onCheckReturn = async () => {
        setShowCommentApprover(true);
        
        // ทำการ submit form เพื่อ trigger การ validate
        await validationReturn.submitForm();
        // ตรวจสอบค่าของ showCommentApprover
        if (showCommentApprover) {
            // ตรวจสอบว่ามีข้อผิดพลาดหรือไม่
            const errors = validationReturn.errors;
            // console.log(errors);
            
            if (Object.keys(errors).length === 0) {
                // ตรวจสอบสิทธิ์การอนุมัติ
                if (checkAuthorizedReturn) {
                    onReturn(dataFormRequest, validation.values);
                } else {
                    Swal.fire({
                        iconHtml: IconAlertError,
                        title: "You Are not authorized to action this.",
                        showConfirmButton: false,
                        showCloseButton: true,
                    });
                }
            } else {
                // ถ้ามีข้อผิดพลาด แสดงข้อความเตือน
                Swal.fire({
                    iconHtml: IconAlertError,
                    title: "กรุณากรอกข้อมูลความเห็นของผู้อนุมัติ",
                    showConfirmButton: false,
                    showCloseButton: true,
                });
            }
        }
    };

    const onReturn = (dataRequest, dataFormGct) => {
        // setIsShowModal(!isShowModal);
        Swal.fire({
            icon: 'info',
            title: 'Loading...',
            showConfirmButton: false,
            allowOutsideClick: false,
            allowEscapeKey: false,
            willOpen: () => {
                Swal.showLoading();
            }
        });
  
        let isSaveSucess = true;
        (async () => {
            try{
                let dataReturn = await ApprovalReturn(dataRequest.id);
                isSaveSucess = (dataReturn.is_sucess === true && isSaveSucess === true) ? true : false;
                
                const dataRequestWorkFlows = {
                    "id_request": dataRequest.id,
                    "id_workflow_status" : 4,
                    "do_by" : userEmail,
                    "send_to" : dataRequest.request_by,
                    "cc_to" : null,
                    "comment" : dataFormGct.approver_comment,
                    "document" : null,
                    "consent" : null,
                    "do_date" : newDateTime,
                };
                let dataRequestWorkFlow = await AddRequestWorkFlow(dataRequestWorkFlows);
                isSaveSucess = (dataRequestWorkFlow.is_sucess === true && isSaveSucess === true) ? true : false;

                const {
                    approve_request_by,
                    require_handled_by,
                    request_no,
                    ...postdataFormGct //delete data json
                } = dataFormGct;

                let formGct;
                if(postdataFormGct.business_unit_other !== "" && postdataFormGct.id_business_unit === "-1") {
                    const postdataRequest = {
                        ...dataRequest,
                        id: dataRequest.id,
                        id_business_unit : postdataFormGct.business_unit_other !== "" ? "-1" : postdataFormGct.id_business_unit,
                        business_unit_other : postdataFormGct.business_unit_other,
                        id_confidential_level: postdataFormGct.id_confidential_level,
                    };
                    let dataRequestForm = await UpdateRequests(postdataRequest);
                    isSaveSucess = (dataRequestForm.is_sucess === true && isSaveSucess === true) ? true : false;
                    // console.log(dataRequest);

                    const updatedDataCompany = {
                        ...postdataFormGct,
                        id_business_unit: dataRequest.id_business_unit,
                    };
                    formGct = await UpdateFormCsa(updatedDataCompany);
                } else {
                    const postdataRequest = {
                        ...dataRequest,
                        id: dataRequest.id,
                        id_business_unit : postdataFormGct.business_unit_other !== "" ? "-1" : postdataFormGct.id_business_unit,
                        business_unit_other : postdataFormGct.business_unit_other,
                        id_confidential_level: postdataFormGct.id_confidential_level,
                    };
                    // console.log(postdataRequest);
                    let dataRequestForm = await UpdateRequests(postdataRequest);
                    isSaveSucess = (dataRequestForm.is_sucess === true && isSaveSucess === true) ? true : false;

                    formGct = await UpdateFormCsa(postdataFormGct);
                }
                isSaveSucess = (formGct.is_sucess === true && isSaveSucess === true) ? true : false;

                if(isSaveSucess === true){
                    let isSendMail = await SendMailReturn(dataRequestWorkFlow.data[0]);
                    if( isSendMail === true ){
                        Swal.close(); // Close loading spinner
                        Swal.fire({
                                iconHtml: IconAlertReturn,
                                title: "Return to user who request.",
                                showConfirmButton: false,
                                showCloseButton: true,
                                // showConfirmButton: false,
                            }).then(() => {
                                // props.nextStep();
                                history.push(GetUrlBack());
                            });
                    }else{
                        Swal.close(); // Close loading spinner
                        Swal.fire({
                            iconHtml: IconAlertError,
                            title: "Failed to send email to user who request.",
                            showConfirmButton: false,
                            showCloseButton: true,
                        });
                    }
                }else{
                    Swal.close(); // Close loading spinner
                    Swal.fire({
                        iconHtml: IconAlertError,
                        title: "Failed to save data.",
                        showConfirmButton: false,
                        showCloseButton: true,
                    });
                }
            } catch(error){
                console.log(error);
            }
        })();
    };

    const ApprovalReturn = async (id) => {
        let url = ConfigData.API_URL + "request/approval-return/" + id;
        let token = "Bearer " + localStorage.getItem("tkd");
        let userId = (!localStorage.getItem("emd")) ? "" : atob(localStorage.getItem("emd"));
        try {
            const resp = await axios.put(url,{}, { headers: { 
                                        'Authorization' : token,
                                        'User': userId,
                                    }, responseType: "json" });
            let respData = resp.data;
            // setDataIdRequest(respData.data)
            return respData;
        }catch(error){
            // handlerRespError(error, history);
            console.log(error);
            return false;
        }
    };

    const UpdateRequests = async (data) => {
        let url = ConfigData.API_URL + "request/" + data.id;
        let token = "Bearer " + localStorage.getItem("tkd");
        let userId = (!localStorage.getItem("emd")) ? "" : atob(localStorage.getItem("emd"));
        try {
            const resp = await axios.put(url, data, { headers: { 
                                        'Authorization' : token,
                                        'User': userId,
                                    }, responseType: "json" });
            let respData = resp.data;
            // setDataIdRequest(respData.data)
            return respData;
        }catch(error){
            // handlerRespError(error, history);
            console.log(error);
            return false;
        }
    };

    const UpdateFormCsa = async (data) => {
        let url = ConfigData.API_URL + "form-csa/" + data.id;
        let token = "Bearer " + localStorage.getItem("tkd");
        let userId = (!localStorage.getItem("emd")) ? "" : atob(localStorage.getItem("emd"));
        try {
            const resp = await axios.put(url, data, { headers: { 
                                        'Authorization' : token,
                                        'User': userId,
                                    }, responseType: "json" });
            let respData = resp.data;
            // console.log(respData);
            return respData;
        }catch(error){
            // handlerRespError(error, history);
            console.log(error);
            return false;
        }
    };

    const AddRequestWorkFlow = async (dataRequestWorkFlows) => {
        let url = ConfigData.API_URL + "request-workflow/";
        let data = dataRequestWorkFlows;
        let token = "Bearer " + localStorage.getItem("tkd");
        let userId = (!localStorage.getItem("emd")) ? "" : atob(localStorage.getItem("emd"));
        try {
            const resp = await axios.post(url, data, { headers: { 
                                'Authorization' : token,
                                'User': userId,
                            }, responseType: "json" }
                        );
            let respData = resp.data;
            return respData;
        }catch(error){
            // handlerRespError(error, history);
            console.log(error);
            return false;
        }
    };

    const SendMailReturn = async (data) => {
        const url = ConfigData.API_URL + "email/send";
        const token = "Bearer " + localStorage.getItem("tkd");
        const userId = (!localStorage.getItem("emd")) ? "" : atob(localStorage.getItem("emd"));
        let arrTo = data.send_to.split(",");
        let dataReq = {
            "to": arrTo,
            "template_id": 2,
            "request_id": data.id_request,
        };
        try {
            const resp = await axios.post(url, dataReq, { headers: { 
                'Authorization' : token,
                'User': userId,
            }, responseType: "json" });
            let respData = resp.data;
            return respData.is_sucess;
        } catch(error){
            // handlerRespError(error, history);
            console.log(error);
            return false;
        }
    };

    return (
        <React.Fragment>
            <div className="mx-auto">
                <Form className="needs-validation"
                    onSubmit={(e) => {
                        e.preventDefault();
                        validation.handleSubmit();
                        validationDraft.handleSubmit();
                        validationReturn.handleSubmit();
                        return false;
                    }}
                >
                <div id="section-page-1-2">
                    <Row>
                        <Col md={12} className="mb-3">
                            <span className="span-title">
                                ข้อมูลทั่วไป (Request General Information)
                            </span>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={5}>
                            <FormGroup>
                                <Label className="label-title">ประเภทคำขอ (Type of Request)</Label>
                                <Input id="txtTypeOfRequest"
                                    type="text"
                                    name="typeOfRequest"
                                    value={dataFormRequest.name_en_request_type ? dataFormRequest.name_en_request_type || "" : formTemp.name_en_request_type || ""}
                                    disabled
                                />
                            </FormGroup>
                        </Col>
                        <Col md={5}>
                            <FormGroup>
                                <Label className="label-title">เรื่อง (Matters)</Label>
                                <Input id="txtTypeOfRequest"
                                    type="text"
                                    name="typeOfRequest"
                                    value={dataFormRequest.name_en_sub_request_type ? dataFormRequest.name_en_sub_request_type || "" : formTemp.name_en_sub_request_type || ""}
                                    disabled
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={10}>
                            <FormGroup>
                                <Label className="label-title">ชื่อโครงการ (Project Name)</Label>
                                <i className="mdi mdi-help-circle icon-hint-right" id="prProjectName"></i>
                                <div className="hstack flex-wrap gap-2">
                                    <UncontrolledPopover placement="right" target="prProjectName" >
                                        <PopoverBody className="msg-show-hint"><i className="mdi mdi-help-circle msg-icon-hint"></i> โปรดระบุชื่อโครงการ (ถ้ามี)<br/>Please specify project name (if any)​</PopoverBody>
                                    </UncontrolledPopover>
                                </div>
                                <Input id="txtProjectName"
                                    name="project_name"
                                    placeholder="ระบุชื่อโครงการ(ถ้ามี)"
                                    type="text"
                                    className="from-control txt-placeholder"
                                    onChange={(e) => {
                                        validation.handleChange(e);
                                        validationDraft.handleChange(e);
                                        setIsSaveEnabled(true);
                                    }}
                                    onBlur={validation.handleBlur}
                                    value={validation.values.project_name || ""}
                                    invalid={ validation.touched.project_name && validation.errors.project_name ? true : false }
                                    disabled={isDisableds}
                                />
                                { validation.touched.project_name && validation.errors.project_name ? ( 
                                    <FormFeedback type="invalid" style={{display: "block"}}>
                                        {validation.errors.project_name}
                                    </FormFeedback> 
                                ) : false }
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={10}>
                            <FormGroup>
                                <Label className="label-title">ต้องการให้ฝ่ายกฎหมายดำเนินการ (Request Legal Team to)<span className="msg-require">*</span></Label>
                                <i className="mdi mdi-help-circle icon-hint-right" id="prReqLegalTeamTo"></i>
                                <div className="hstack flex-wrap gap-2">
                                    <UncontrolledPopover placement="right" target="prReqLegalTeamTo" >
                                        <PopoverBody className="msg-show-hint"><i className="mdi mdi-help-circle msg-icon-hint"></i> หากเป็นกรณีแก้ไขเปลี่ยนแปลงรายละเอียดของสัญญาเดิม ขอให้แนบสัญญาเดิมประกอบมาด้วย<br/>In case of amendment of the existing agreement, please attach the existing agreement file.​</PopoverBody>
                                    </UncontrolledPopover>
                                </div>
                                <Select id="ddlReqLegalTeamTo"
                                    name="req_legal_team_to"
                                    value={selectReqLegalTeamTo}
                                    className="txt-placeholder"
                                    placeholder="เลือกความต้องการในการดำเนินการ"
                                    onChange={(selected) => {
                                        setSelectReqLegalTeamTo(selected);
                                        const selectedValue = (selected !== null) ? selected.value : "";
                                        validation.handleChange("req_legal_team_to")((selected !== null) ? selectedValue : "");
                                        validationDraft.handleChange("req_legal_team_to")((selected !== null) ? selectedValue : "");
                                        setIsSaveEnabled(true);
                                        if( selectedValue === "1"){
                                            setAttachDraft(true);
                                        } else {
                                            setFilenameReqLegalTeamToDoc("");
                                            setAttachDraft(false);
                                            setFileReqLegalTeamToDoc([]);
                                            // validation.setFieldValue("req_legal_team_to_doc", "");
                                        }
                                    }}
                                    options={ddlReqLegalTeamTo}
                                    isClearable={true}
                                    isSearchable={true}
                                    isDisabled={isDisableds}
                                    invalid={ validation.touched.req_legal_team_to && validation.errors.req_legal_team_to ? true : false }
                                />
                                { validation.touched.req_legal_team_to && validation.errors.req_legal_team_to ? ( 
                                    <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">
                                        {validation.errors.req_legal_team_to}
                                    </FormFeedback> 
                                ) : false }  
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={10}>
                            <SingleUploadfile inputID="regLegalTeamToDoc" folder={dataFormRequest.request_no} dataFile={fileReqLegalTeamToDoc} setDataFile={OnSetFileReqLegalTeamToDoc} isDisable={(selectReqLegalTeamTo !== null && selectReqLegalTeamTo?.value === "1") || AttachDraft === true ? false : true} />
                            { validation.touched.req_legal_team_to_doc && validation.errors.req_legal_team_to_doc ?  ( 
                                <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">
                                    {validation.errors.req_legal_team_to_doc}
                                </FormFeedback> 
                            ) : false }
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12}>
                            <div className="line-border"></div>
                        </Col>
                    </Row>
                </div>
                <div id="section-page-2-1">
                    <Row>
                        <Col md={12} className="mb-3">
                            <span className="span-title">
                                ชื่อคู่สัญญา (The Parties)
                            </span>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={5}>
                            <FormGroup>
                                <Label className="label-title">ทำสัญญาในนามของ (Company Name)<span className="msg-require">*</span></Label>
                                <i className="mdi mdi-help-circle icon-hint-right" id="prBU"></i>
                                <div className="hstack flex-wrap gap-2">
                                    <UncontrolledPopover placement="right" target="prBU" >
                                        <PopoverBody className="msg-show-hint"><i className="mdi mdi-help-circle msg-icon-hint"></i> โปรดระบุว่าจะเข้าทำสัญญาในนามของบริษัทในเครือรายใด หาก user ต้องการระบุชื่อบริษัทที่ไม่มี ในรายชื่อบริษัท โปรดเลือก Others และกรอกชื่อบริษัทดังกล่าว<br/>Please indicate the company or affiliate name who is the party. If the party is not listed here, please select 'Others' and provide such company's name.​</PopoverBody>
                                    </UncontrolledPopover>
                                </div>
                                <Select id="ddlIdBusinessUnit"
                                    name="id_business_unit"
                                    value={selectBU}
                                    className="txt-placeholder"
                                    placeholder="ระบุชื่อในการทำสัญญา"
                                    onChange={(selected) => {
                                        setSelectBU(selected);
                                        validation.handleChange("id_business_unit")((selected !== null) ? selected.value : "");
                                        validationDraft.handleChange("id_business_unit")((selected !== null) ? selected.value : "");
                                        setIsSaveEnabled(true);
                                    }}
                                    options={ddlBU}
                                    isClearable={true}
                                    isSearchable={true}
                                    invalid={ validation.touched.id_business_unit && validation.errors.id_business_unit ? true : false }
                                    isDisabled={companyDisabled} // Set disabled based on the variable
                                />
                                { validation.touched.id_business_unit && validation.errors.id_business_unit ? ( 
                                    <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">
                                        {validation.errors.id_business_unit}
                                    </FormFeedback> 
                                ) : false }   
                            </FormGroup>
                        </Col>
                        <Col md={5}>
                            <FormGroup>
                                <Input
                                    type="checkbox"
                                    name="checkbox_business_unit_other"
                                    checked={isCheckedCompanyOther}
                                    onChange={handleCheckboxChangeCompanyOther}
                                    />
                                <Label className="label-title"> อื่นๆ (Others)</Label>
                                <Input
                                type="text"
                                name="business_unit_other"
                                className="txt-placeholder"
                                autoComplete={autoCompletes}
                                placeholder={otherCompanyPlaceholder}
                                onChange={(e) => {
                                    validation.handleChange(e);
                                    validationDraft.handleChange(e);
                                    setIsSaveEnabled(true);
                                }}
                                onBlur={validation.handleBlur}
                                value={otherCompanyDisabled === true ? "" : validation.values.business_unit_other || ""}
                                invalid={validation.touched.business_unit_other && validation.errors.business_unit_other ? true : false}
                                disabled={otherCompanyDisabled}
                                />
                                {validation.touched.business_unit_other && validation.errors.business_unit_other ? (
                                <FormFeedback type="invalid" style={{ display: "block" }} className="msg-show-hint">
                                    {validation.errors.business_unit_other}
                                </FormFeedback>
                                ) : false}
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={10}>
                            <FormGroup>
                                <Label className="label-title">โดยเป็นฝ่าย (Act as)<span className="msg-require">*</span></Label>
                                <i className="mdi mdi-help-circle icon-hint-right" id="prBusinessUnitActAs"></i>
                                <div className="hstack flex-wrap gap-2">
                                    <UncontrolledPopover placement="right" target="prBusinessUnitActAs" >
                                        <PopoverBody className="msg-show-hint"><i className="mdi mdi-help-circle msg-icon-hint"></i> โปรดระบุหน้าที่และความรับผิดชอบโดยสังเขปตามสัญญาของบริษัทโดยสังเขป<br/>Please specify shortly of duty and responsibility of Company.​</PopoverBody>
                                    </UncontrolledPopover>
                                </div>
                                {/* <Input id="txtBusinessUnitActAs"
                                    name="business_unit_act_as"
                                    placeholder="ระบุสถานะในสัญญา"
                                    type="text"
                                    className="from-control txt-placeholder"
                                    onChange={(e) => {
                                        validation.handleChange(e);
                                        validationDraft.handleChange(e);
                                        setIsSaveEnabled(true);
                                    }}
                                    onBlur={validation.handleBlur}
                                    value={validation.values.business_unit_act_as || ""}
                                    invalid={ validation.touched.business_unit_act_as && validation.errors.business_unit_act_as ? true : false }
                                /> */}
                                <Select
                                    id="businessUnitActAs"
                                    name="business_unit_act_as"
                                    value={selectCompanyActAs}
                                    className="txt-placeholder"
                                    placeholder={"เลือกฝ่ายการดำเนินการ"}
                                    onChange={(selected) => {
                                        setSelectCompanyActAs(selected);
                                        validation.handleChange("business_unit_act_as")((selected !== null) ? selected.value : "");
                                        validationDraft.handleChange("business_unit_act_as")((selected !== null) ? selected.value : "");
                                        setIsSaveEnabled(true);
                                    }}
                                    options={optionDdlCompanyActAs.filter(
                                        (option) => !selectCounterActAs || (selectCounterActAs && option.value !== selectCounterActAs.value)
                                    )}
                                    isClearable={true}
                                    isSearchable={true}
                                    invalid={validation.touched.business_unit_act_as && validation.errors.business_unit_act_as ? true : false}
                                    isDisabled={isDisableds}
                                />
                                { validation.touched.business_unit_act_as && validation.errors.business_unit_act_as ? ( 
                                    <FormFeedback type="invalid" style={{display: "block"}}>
                                        {validation.errors.business_unit_act_as}
                                    </FormFeedback> 
                                ) : false }
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={10}>
                            <FormGroup>
                                <Label className="label-title">ชื่อคู่สัญญาอีกฝ่าย (Counterparty's Name)<span className="msg-require">*</span></Label>
                                <i className="mdi mdi-help-circle icon-hint-right" id="prCounterPartyName"></i>
                                <div className="hstack flex-wrap gap-2">
                                    <UncontrolledPopover placement="right" target="prCounterPartyName" >
                                        <PopoverBody className="msg-show-hint"><i className="mdi mdi-help-circle msg-icon-hint"></i> โปรดแนบสำเนาหนังสือรับรองบริษัท/ห้างหุ้นส่วนฯ และ/หรือเอกสารทางราชการอื่น ๆ (เช่น บัตรประชาชน หนังสือเดินทาง)<br/>Please attach the copy of company affidavit/partnership and/or other corporate documents (e.g. ID card and passport)​</PopoverBody>
                                    </UncontrolledPopover>
                                </div>
                                <Input id="txtCounterPartyName"
                                    name="counterparty_name"
                                    placeholder="ระบุชื่อคู่สัญญาอีกฝ่าย"
                                    type="text"
                                    className="from-control txt-placeholder"
                                    onChange={(e) => {
                                        validation.handleChange(e);
                                        validationDraft.handleChange(e);
                                        setIsSaveEnabled(true);
                                    }}
                                    disabled={isDisableds}
                                    onBlur={validation.handleBlur}
                                    value={validation.values.counterparty_name || ""}
                                    invalid={ validation.touched.counterparty_name && validation.errors.counterparty_name ? true : false }
                                />
                                { validation.touched.counterparty_name && validation.errors.counterparty_name ? ( 
                                    <FormFeedback type="invalid" style={{display: "block"}}>
                                        {validation.errors.counterparty_name}
                                    </FormFeedback> 
                                ) : false }
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={10}>
                            <FormGroup>
                                <SingleUploadfile inputID="counterpartyDoc" folder={dataFormRequest.request_no} dataFile={fileCounterpartyDoc} setDataFile={OnSetFileCounterpartyDoc} isDisable={isDisableds} />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={10}>
                            <FormGroup>
                                <Label className="label-title">โดยเป็นฝ่าย (Act as)<span className="msg-require">*</span></Label>
                                <i className="mdi mdi-help-circle icon-hint-right" id="prCounterPartyActAs"></i>
                                <div className="hstack flex-wrap gap-2">
                                    <UncontrolledPopover placement="right" target="prCounterPartyActAs" >
                                        <PopoverBody className="msg-show-hint"><i className="mdi mdi-help-circle msg-icon-hint"></i> โปรดระบุหน้าที่และความรับผิดชอบโดยสังเขปตามสัญญาของคู่สัญญาโดยสังเขป<br/>Please specify shortly of duty and responsibility of Counterparty.​</PopoverBody>
                                    </UncontrolledPopover>
                                </div>
                                {/* <Input id="txtCounterPartyActAs"
                                    name="counterparty_act_as"
                                    placeholder="ระบุสถานะในสัญญา"
                                    type="text"
                                    className="from-control txt-placeholder"
                                    onChange={(e) => {
                                        validation.handleChange(e);
                                        validationDraft.handleChange(e);
                                        setIsSaveEnabled(true);
                                    }}
                                    onBlur={validation.handleBlur}
                                    value={validation.values.counterparty_act_as || ""}
                                    invalid={ validation.touched.counterparty_act_as && validation.errors.counterparty_act_as ? true : false }
                                /> */}
                                <Select
                                    id="counterpartyActAs"
                                    name="counterparty_act_as"
                                    value={selectCounterActAs}
                                    className="txt-placeholder"
                                    placeholder={"เลือกฝ่ายการดำเนินการ"}
                                    onChange={(selected) => {
                                        setSelectCounterActAs(selected);
                                        validation.handleChange("counterparty_act_as")((selected !== null) ? selected.value : "");
                                        validationDraft.handleChange("counterparty_act_as")((selected !== null) ? selected.value : "");
                                        setIsSaveEnabled(true);
                                    }}
                                    options={optionDdlCounterActAs.filter(
                                        (option) => !selectCompanyActAs || (selectCompanyActAs && option.value !== selectCompanyActAs.value)
                                    )}
                                    isClearable={true}
                                    isSearchable={true}
                                    invalid={validation.touched.counterparty_act_as && validation.errors.counterparty_act_as ? true : false}
                                    isDisabled={isDisableds}
                                />
                                { validation.touched.counterparty_act_as && validation.errors.counterparty_act_as ? ( 
                                    <FormFeedback type="invalid" style={{display: "block"}}>
                                        {validation.errors.counterparty_act_as}
                                    </FormFeedback> 
                                ) : false }
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12}>
                            <div className="line-border"></div>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12} className="mb-3">
                            <span className="span-title">
                                รายละเอียดการดำเนินการตามสัญญา (Performance of Each Party Details)
                            </span>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={10}>
                            <FormGroup>
                                <Label className="label-title">วัตถุประสงค์ของการทำสัญญา (Purpose)<span className="msg-require">*</span></Label>
                                <Label className="label-title-purpose">
                                ขอให้ระบุรายละเอียดอย่างย่อของสัญญาว่าเป็นเรื่องเกี่ยวกับอะไร เช่น สัญญาจ้างบริหารจัดการด้านบัญชี/ การตลาด, สัญญาเช่ารถยนต์ ทะเบียนเลขที่ x-xxx, สัญญาจ้างเหมาทำความสะอาด อาคาร xx, สัญญาซื้อขายพร้อมติดตั้งลิฟท์, สัญญาให้บริการซอฟท์แวร์ xxxx เป็นต้น โดยห้ามระบุว่า ’ตามเอกสารแนบ’ หรือคำอื่นใดที่ไม่แสดงให้ทราบได้ว่า เป็นสัญญาเกี่ยวกับเรื่องอะไร มิฉะนั้น ฝ่ายกฎหมายขอสงวนสิทธิ์กด Reject งานนั้น
                                </Label>
                                <Input
                                    type="textarea"
                                    name="purpose"
                                    placeholder="ระบุรายละเอียดอย่างย่อของสัญญาว่าเป็นเรื่องเกี่ยวกับอะไรให้ชัดเจน"
                                    autoComplete={autoCompletes}
                                    className="txt-text-area"
                                    onChange={(e) => {
                                        validation.handleChange(e);
                                        validationDraft.handleChange(e);
                                        setIsSaveEnabled(true);
                                    }}
                                    onBlur={validation.handleBlur}
                                    value={validation.values.purpose || ""}
                                    invalid={validation.touched.purpose && validation.errors.purpose ? true : false}
                                    disabled={isDisableds}
                                />
                                { validation.touched.purpose && validation.errors.purpose ? ( 
                                    <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">
                                        {validation.errors.purpose}
                                    </FormFeedback>
                                ) : false }
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={10}>
                            <FormGroup>
                                <Label className="label-title">สถานที่ที่ปฏิบัติงาน (Place of Performance)<span className="msg-require">*</span></Label>
                                <i className="mdi mdi-help-circle icon-hint-right" id="prPlaceOfPerformance"></i>
                                <div className="hstack flex-wrap gap-2">
                                    <UncontrolledPopover placement="right" target="prPlaceOfPerformance" >
                                        <PopoverBody className="msg-show-hint"><i className="mdi mdi-help-circle msg-icon-hint"></i> โปรดระบุรายละเอียดที่อยู่โดยละเอียด กล่าวคือ บ้านเลขที่ อาคาร ชั้น ห้อง ฯลฯ<br/>Please specify the address of place of performance (e.g. house no., building, floor, room etc.)​</PopoverBody>
                                    </UncontrolledPopover>
                                </div>
                                <Input id="txtPlaceOfPerformance"
                                    name="place_of_performance"
                                    placeholder="ระบุสถานที่ปฏิบัติงานโดยละเอียด"
                                    type="text"
                                    className="from-control txt-placeholder"
                                    onChange={(e) => {
                                        validation.handleChange(e);
                                        validationDraft.handleChange(e);
                                        setIsSaveEnabled(true);
                                    }}
                                    disabled={isDisableds}
                                    onBlur={validation.handleBlur}
                                    value={validation.values.place_of_performance || ""}
                                    invalid={ validation.touched.place_of_performance && validation.errors.place_of_performance ? true : false }
                                />
                                { validation.touched.place_of_performance && validation.errors.place_of_performance ? ( 
                                    <FormFeedback type="invalid" style={{display: "block"}}>
                                        {validation.errors.place_of_performance}
                                    </FormFeedback> 
                                ) : false }
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={10}>
                            <FormGroup>
                                <Label className="label-title">
                                    หน้าที่และความรับผิดชอบในการปฏิบัติตามสัญญาของคู่สัญญาแต่ละฝ่าย 
                                    <br />
                                    (Duties and Responsibilities of Each Party)
                                    <span className="msg-require">*</span>
                                </Label>
                                <i className="mdi mdi-help-circle icon-hint-right" id="prResponsibilitiesEachParty"></i>
                                <div className="hstack flex-wrap gap-2">
                                    <UncontrolledPopover placement="right" target="prResponsibilitiesEachParty" >
                                        <PopoverBody className="msg-show-hint"><i className="mdi mdi-help-circle msg-icon-hint"></i> โปรดระบุรายละเอียดหน้าที่และความรับผิดชอบของคู่สัญญาแต่ละฝ่ายโดยละเอียด เช่น ทำอะไร, เพื่ออะไร, แต่ละฝ่ายได้รับอะไร, หรือต้องจัดหาอะไรให้แก่อีกฝ่าย ฯลฯ<br/>Please specify detail of duties and responnsiblities of each party according to the agreement (e.g. what shall each party be obliged to do, what shall each party aim to recieve, or what shall each party be responsible to provide for another party etc.)​</PopoverBody>
                                    </UncontrolledPopover>
                                </div>
                                <Input id="txtResponsibilitiesEachParty"
                                    name="responsibilities_each_party"
                                    placeholder="ระบุรายละเอียดหน้าที่และความรับผิดของคู่สัญญาแต่ละฝ่าย"
                                    type="text"
                                    className="from-control txt-placeholder"
                                    onChange={(e) => {
                                        validation.handleChange(e);
                                        validationDraft.handleChange(e);
                                        setIsSaveEnabled(true);
                                    }}
                                    disabled={isDisableds}
                                    onBlur={validation.handleBlur}
                                    value={validation.values.responsibilities_each_party || ""}
                                    invalid={ validation.touched.responsibilities_each_party && validation.errors.responsibilities_each_party ? true : false }
                                />
                                { validation.touched.responsibilities_each_party && validation.errors.responsibilities_each_party ? ( 
                                    <FormFeedback type="invalid" style={{display: "block"}}>
                                        {validation.errors.responsibilities_each_party}
                                    </FormFeedback> 
                                ) : false }
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={10}>
                            <Label className="label-title mb-3">
                                เอกสารแนบเพื่อพิจารณา (Attachment)<span className="msg-require">*</span>
                            </Label>
                            <SingleUploadfile inputID="detailContractDoc" folder={dataFormRequest.request_no} dataFile={fileDetailContractDoc} setDataFile={OnSetFileDetailContractDoc} isDisable={isDisableds}/>
                            { validation.touched.detail_contract_doc && validation.errors.detail_contract_doc ? ( 
                                <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">
                                    {validation.errors.detail_contract_doc}
                                </FormFeedback> 
                            ) : false }
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12}>
                            <div className="line-border"></div>
                        </Col>
                    </Row>
                </div>
                <div id="section-page-3-1">
                    <Row>
                        <Col md={12} className="mb-3">
                            <span className="span-title">
                                ระยะเวลาของสัญญา (Term)
                            </span>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={5}>
                            <FormGroup>
                                <Label className="label-title">วันเริ่มต้น (Commencement Date)<span className="msg-require">*</span></Label>
                                <i className="mdi mdi-help-circle icon-hint-right" id="prTermStartDate"></i>
                                <div className="hstack flex-wrap gap-2">
                                    <UncontrolledPopover placement="right" target="prTermStartDate" >
                                        <PopoverBody className="msg-show-hint"><i className="mdi mdi-help-circle msg-icon-hint"></i> โปรดระบุวัน/เดือน/ปี เริ่มต้นและสิ้นสุดสัญญา กรณีเป็นสัญญาปลายเปิด ไม่ต้องระบุวันสิ้นสุดสัญญา<br/>Please specify DD/MM/YYYY of Commencement and Expiry Date of the Agreement. In no period set, specification of DD/NMM/YYYY is not required​</PopoverBody>
                                    </UncontrolledPopover>
                                </div>
                                <Input id="txtTermStartDate"
                                    name="term_start_date"
                                    type="date"
                                    className="form-control"
                                    value={validation.values.term_start_date || ""}
                                    onChange={(e) => {
                                        validation.handleChange(e);
                                        validationDraft.handleChange(e);
                                        setIsSaveEnabled(true);
                                    }}
                                    disabled={isDisableds}
                                    onBlur={validation.handleBlur}
                                    invalid={ validation.touched.term_start_date && validation.errors.term_start_date ? true : false }
                                />
                                { validation.touched.term_start_date && validation.errors.term_start_date ? ( 
                                    <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">
                                        {validation.errors.term_start_date}
                                    </FormFeedback>
                                ) : false }
                            </FormGroup>
                        </Col>
                        <Col md={5}>
                            <FormGroup>
                                <Label className="label-title">วันสิ้นสุดสัญญา (Expiry Date)</Label>
                                <Input id="txtTermEndDate"
                                    name="term_end_date"
                                    type="date"
                                    className="form-control"
                                    value={validation.values.term_end_date || ""}
                                    onChange={(e) => {
                                        validation.handleChange(e);
                                        validationDraft.handleChange(e);
                                        setIsSaveEnabled(true);
                                    }}
                                    disabled={isDisableds}
                                    onBlur={validation.handleBlur}
                                    invalid={ validation.touched.term_end_date && validation.errors.term_end_date ? true : false }
                                />
                                { validation.touched.term_end_date && validation.errors.term_end_date ? ( 
                                    <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">
                                        {validation.errors.term_end_date}
                                    </FormFeedback>
                                ) : false }
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={10}>
                            <FormGroup>
                                <Label className="label-title">เงื่อนไขการต่ออายุสัญญา (Renewal Term)</Label>
                                <i className="mdi mdi-help-circle icon-hint-right" id="prRenewalTerm"></i>
                                <div className="hstack flex-wrap gap-2">
                                    <UncontrolledPopover placement="right" target="prRenewalTerm" >
                                        <PopoverBody className="msg-show-hint"><i className="mdi mdi-help-circle msg-icon-hint"></i> เช่น การขอต่ออายุสัญญาต้องแจ้งล่วงหน้า….เดือน โดยค่าจ้าง/ค่าบริการจะปรับขึ้นร้อยละ…. เป็นต้น<br/>Please specify the renewal term (e.g. The parties have to notify the other party in advance at least ….. Month and the service fee will increase at the rate of ... %)​</PopoverBody>
                                    </UncontrolledPopover>
                                </div>
                                <Input id="txtRenewalTerm"
                                    name="renewal_term"
                                    placeholder="โปรดระบุเงื่อนไขการต่ออายุสัญญา"
                                    type="text"
                                    className="from-control txt-placeholder"
                                    onChange={(e) => {
                                        validation.handleChange(e);
                                        validationDraft.handleChange(e);
                                        setIsSaveEnabled(true);
                                    }}
                                    disabled={isDisableds}
                                    onBlur={validation.handleBlur}
                                    value={validation.values.renewal_term || ""}
                                    invalid={ validation.touched.renewal_term && validation.errors.renewal_term ? true : false }
                                />
                                { validation.touched.renewal_term && validation.errors.renewal_term ? ( 
                                    <FormFeedback type="invalid" style={{display: "block"}}>
                                        {validation.errors.renewal_term}
                                    </FormFeedback> 
                                ) : false }
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12}>
                            <div className="line-border"></div>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12} className="mb-3">
                            <span className="span-title">
                                ค่าตอบแทน (Price)
                            </span>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={10}>
                            <FormGroup>
                                <Label className="label-title">อัตราหรือจำนวนค่าตอบแทน (Rate of Price)<span className="msg-require">*</span></Label>
                                <i className="mdi mdi-help-circle icon-hint-right" id="prRateOfPrice"></i>
                                <div className="hstack flex-wrap gap-2">
                                    <UncontrolledPopover placement="right" target="prRateOfPrice" >
                                        <PopoverBody className="msg-show-hint"><i className="mdi mdi-help-circle msg-icon-hint"></i> โปรดระบุอัตราหรือจำนวนค่าตอบแทนที่แต่ละฝ่ายได้รับ หรือที่คู่สัญญาฝ่ายหนึ่งจะจ่ายให้อีกฝ่ายหนึ่ง (ฝ่ายใดเป็นผู้จ่าย ฝ่ายใดเป็นผู้รับ) และเงื่อนไขการจ่าย เช่น เมื่อได้รับเงินจาก xxx แล้ว หรือเงื่อนไขอื่นใด<br/>Please specify the rate of price or amount of remuneration of which each or both parties shall recieve or shall be responsible to pay (depending on which party is payer or receiver) and payment condition (e.g. upon the complete payment from........ or other conditions)</PopoverBody>
                                    </UncontrolledPopover>
                                </div>
                                <Input id="txtRateOfPrice"
                                    name="rate_of_price"
                                    placeholder="โปรดระบุอัตราหรือจำนวนค่าตอบแทน"
                                    type="text"
                                    className="from-control txt-placeholder"
                                    onChange={(e) => {
                                        validation.handleChange(e);
                                        validationDraft.handleChange(e);
                                        setIsSaveEnabled(true);
                                    }}
                                    disabled={isDisableds}
                                    onBlur={validation.handleBlur}
                                    value={validation.values.rate_of_price || ""}
                                    invalid={ validation.touched.rate_of_price && validation.errors.rate_of_price ? true : false }
                                />
                                { validation.touched.rate_of_price && validation.errors.rate_of_price ? ( 
                                    <FormFeedback type="invalid" style={{display: "block"}}>
                                        {validation.errors.rate_of_price}
                                    </FormFeedback> 
                                ) : false }
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={10}>
                            <FormGroup>
                                <Label className="label-title">กำหนดการชำระเงิน (Payment Term)<span className="msg-require">*</span></Label>
                                <i className="mdi mdi-help-circle icon-hint-right" id="prPaymentTerm"></i>
                                <div className="hstack flex-wrap gap-2">
                                    <UncontrolledPopover placement="right" target="prPaymentTerm" >
                                        <PopoverBody className="msg-show-hint"><i className="mdi mdi-help-circle msg-icon-hint"></i> หากชำระครั้งเดียวให้ระบุว่าเมื่อใด เช่น ภายในกี่วันนับจากวันที่ลงนามในสัญญา เป็นต้น<br/>หากชำระเป็นรายงวด ขอให้ระบุรายละเอียดการชำระเงินในแต่ละครั้ง/งวด/เดือน/ปี เช่น งวดที่ 1 ชำระเมื่อ..... งวดที่ 2 ชำระเมื่อ..... ฯลฯ<br/>If the payment will be made in lumpsum, please specify details (e.g. within ... days from the signing date.<br/>If the payment will be made in instalment, please specify details of each instalment ex. First instalment payable at ..... Second instalment payable at ....​</PopoverBody>
                                    </UncontrolledPopover>
                                </div>
                                { validation.touched.payment_term && validation.errors.payment_term ? ( 
                                    <FormFeedback type="invalid" style={{display: "block", marginBottom: "10px"}}>
                                        {validation.errors.payment_term}
                                    </FormFeedback> 
                                ) : false }
                                <div className="form-check ms-4">
                                    <Input id="cbLumpSum"
                                        name="payment_term"
                                        className="form-check-input" 
                                        type="radio"
                                        checked={paymentTerm === "1"}
                                        onChange={() => {
                                            setPaymentTerm("1");
                                            validation.handleChange('payment_term')("1");
                                            validationDraft.handleChange('payment_term')("1");
                                            setIsSaveEnabled(true);
                                            // set enabled is true / false
                                            setPaymentTermDisabled1(false);
                                            setPaymentTermDisabled2(true);
                                            validation.handleChange('payment_term_desc_instalment')("");
                                            validationDraft.handleChange('payment_term_desc_instalment')("");
                                        }}
                                        disabled={isDisableds}
                                    />
                                    <Label className="form-check-label-2row" for="cbLumpSum">
                                        ชำระครั้งเดียว
                                        <br/>
                                        <span className="form-check-label-2row-detail">
                                            Lumpsum (please provide date)
                                        </span>
                                    </Label>
                                </div>
                                <Label className="label-title">ระบุว่าเมื่อใด</Label>
                                <Input id="txtPaymentTermDescLumpSum"
                                    name="payment_term_desc_lump_sum"
                                    placeholder="โปรดระบุเงื่อนไขการต่ออายุสัญญา"
                                    type="text"
                                    className="from-control txt-placeholder"
                                    onChange={(e) => {
                                        validation.handleChange(e);
                                        validationDraft.handleChange(e);
                                        setIsSaveEnabled(true);
                                    }}
                                    onBlur={validation.handleBlur}
                                    value={validation.values.payment_term_desc_lump_sum || ""}
                                    invalid={ validation.touched.payment_term_desc_lump_sum && validation.errors.payment_term_desc_lump_sum ? true : false }
                                    disabled={paymentTermDisabled1}
                                />
                                <div className="form-check ms-4 mt-3">
                                    <Input id="cbInstalment"
                                        name="payment_term"
                                        className="form-check-input" 
                                        type="radio"
                                        checked={paymentTerm === "2"}
                                        onChange={() => {
                                            setPaymentTerm("2");
                                            validation.handleChange('payment_term')("2");
                                            validationDraft.handleChange('payment_term')("2");
                                            setIsSaveEnabled(true);
                                            // set enabled is true / false
                                            setPaymentTermDisabled1(true);
                                            setPaymentTermDisabled2(false);
                                            validation.handleChange('payment_term_desc_lump_sum')("");
                                            validationDraft.handleChange('payment_term_desc_lump_sum')("");
                                        }}
                                        disabled={isDisableds}
                                    />
                                    <Label className="form-check-label-2row" for="cbInstalment">
                                        ชำระรายครั้ง/รายงวด/รายเดือน/ปี
                                        <br/>
                                        <span className="form-check-label-2row-detail">
                                            Instalments (please provide details)
                                        </span>
                                    </Label>
                                </div>
                                <Label className="label-title">ระบุรายละเอียดการชำระเงิน</Label>
                                <Input id="txtPaymentTermDescInstalment"
                                    name="payment_term_desc_instalment"
                                    placeholder="โปรดระบุเงื่อนไขการต่ออายุสัญญา"
                                    type="text"
                                    className="from-control txt-placeholder"
                                    onChange={(e) => {
                                        validation.handleChange(e);
                                        validationDraft.handleChange(e);
                                        setIsSaveEnabled(true);
                                    }}
                                    onBlur={validation.handleBlur}
                                    value={validation.values.payment_term_desc_instalment || ""}
                                    invalid={ validation.touched.payment_term_desc_instalment && validation.errors.payment_term_desc_instalment ? true : false }
                                    disabled={paymentTermDisabled2}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={10}>
                            <FormGroup>
                                <Label className="label-title">ค่าปรับ (Penalty)</Label>
                                <i className="mdi mdi-help-circle icon-hint-right" id="prPenalty"></i>
                                <div className="hstack flex-wrap gap-2">
                                    <UncontrolledPopover placement="right" target="prPenalty" >
                                        <PopoverBody className="msg-show-hint"><i className="mdi mdi-help-circle msg-icon-hint"></i> โปรดระบุอัตราค่าปรับ และเงื่อนไขการปรับ (ถ้ามี) เช่น ค่าปรับกรณีไม่ชำระเงินภายในกำหนด, ค่าปรับกรณีไม่ปฏิบัติตามสัญญา เป็นต้น<br/>Please specify penalty rate and conditions (if any) (e.g. penalty in case of the failure to pay fees within due date, non-compliance with any term and condition set forth in the agreement, etc.)​</PopoverBody>
                                    </UncontrolledPopover>
                                </div>
                                <Input id="txtPenalty"
                                    name="penalty"
                                    placeholder="โปรดระบุเงื่อนไขการต่ออายุสัญญา"
                                    type="text"
                                    className="from-control txt-placeholder"
                                    onChange={(e) => {
                                        validation.handleChange(e);
                                        validationDraft.handleChange(e);
                                        setIsSaveEnabled(true);
                                    }}
                                    disabled={isDisableds}
                                    onBlur={validation.handleBlur}
                                    value={validation.values.penalty || ""}
                                    invalid={ validation.touched.penalty && validation.errors.penalty ? true : false }
                                />
                                { validation.touched.penalty && validation.errors.penalty ? ( 
                                    <FormFeedback type="invalid" style={{display: "block"}}>
                                        {validation.errors.penalty}
                                    </FormFeedback> 
                                ) : false }
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={10}>
                            <FormGroup>
                                <Label className="label-title">การบอกเลิกสัญญา (Termination)</Label>
                                <i className="mdi mdi-help-circle icon-hint-right" id="prTermination"></i>
                                <div className="hstack flex-wrap gap-2">
                                    <UncontrolledPopover placement="right" target="prTermination" >
                                        <PopoverBody className="msg-show-hint"><i className="mdi mdi-help-circle msg-icon-hint"></i> หากมีข้อตกลงในการบอกเลิกสัญญาเป็นกรณีพิเศษ โปรดระบุรายละเอียด<br/>Please specify details if the parties have agreed on special termination cause.​</PopoverBody>
                                    </UncontrolledPopover>
                                </div>
                                <Input id="txtTermination"
                                    name="termination"
                                    placeholder="กรุณากรอกข้อมูล"
                                    type="text"
                                    className="from-control txt-placeholder"
                                    onChange={(e) => {
                                        validation.handleChange(e);
                                        validationDraft.handleChange(e);
                                        setIsSaveEnabled(true);
                                    }}
                                    disabled={isDisableds}
                                    onBlur={validation.handleBlur}
                                    value={validation.values.termination || ""}
                                    invalid={ validation.touched.termination && validation.errors.termination ? true : false }
                                />
                                { validation.touched.termination && validation.errors.termination ? ( 
                                    <FormFeedback type="invalid" style={{display: "block"}}>
                                        {validation.errors.termination}
                                    </FormFeedback> 
                                ) : false }
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12}>
                            <div className="line-border"></div>
                        </Col>
                    </Row>
                </div>
                <div id="section-page-4-1">
                    <Row>
                        <Col md={12} className="mb-3">
                            <span className="span-title">
                                อื่นๆ (Others)
                            </span>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={5}>
                            <FormGroup>
                                <Label className="label-title">อากรแสตมป์ (Stamp Duty)<span className="msg-require">*</span></Label>
                                <i className="mdi mdi-help-circle icon-hint-right" id="prStampDutyPrice"></i>
                                <div className="hstack flex-wrap gap-2">
                                    <UncontrolledPopover placement="right" target="prStampDutyPrice" >
                                        <PopoverBody className="msg-show-hint"><i className="mdi mdi-help-circle msg-icon-hint"></i> โปรดระบุผู้ชำระค่าอากรแสตมป์ (ถ้ามี)<br/>Please specify the responsible party for payment of stamp duty (if any).​</PopoverBody>
                                    </UncontrolledPopover>
                                </div>
                                <Input id="txtStampDutyPrice"
                                    name="stamp_duty_price"
                                    placeholder="ระบุผู้ชำระอากรแสตมป์"
                                    type="text"
                                    className="from-control txt-placeholder"
                                    onChange={(e) => {
                                        validation.handleChange(e);
                                        validationDraft.handleChange(e);
                                        setIsSaveEnabled(true);
                                    }}
                                    disabled={isDisableds}
                                    onBlur={validation.handleBlur}
                                    value={validation.values.stamp_duty_price || ""}
                                    invalid={ validation.touched.stamp_duty_price && validation.errors.stamp_duty_price ? true : false }
                                />
                                { validation.touched.stamp_duty_price && validation.errors.stamp_duty_price ? ( 
                                    <FormFeedback type="invalid" style={{display: "block"}}>
                                        {validation.errors.stamp_duty_price}
                                    </FormFeedback> 
                                ) : false }
                            </FormGroup>
                        </Col>
                        <Col md={5}>
                            <FormGroup>
                                <Label className="label-title">ค่าธรรมเนียมอื่นๆ (Other Fees)</Label>
                                <i className="mdi mdi-help-circle icon-hint-right" id="prOtherFee"></i>
                                <div className="hstack flex-wrap gap-2">
                                    <UncontrolledPopover placement="right" target="prOtherFee" >
                                        <PopoverBody className="msg-show-hint"><i className="mdi mdi-help-circle msg-icon-hint"></i> โปรดระบุผู้ชำระภาษีและค่าธรรมเนียม อื่นๆ (ถ้ามี)<br/>Please specify the responsible party for tax and other fees (if any).​</PopoverBody>
                                    </UncontrolledPopover>
                                </div>
                                <Input id="txtOtherFee"
                                    name="other_fee"
                                    placeholder="โปรดระบุค่าธรรมเนียมอื่นๆและผู้ชำระ"
                                    type="text"
                                    className="from-control txt-placeholder"
                                    onChange={(e) => {
                                        validation.handleChange(e);
                                        validationDraft.handleChange(e);
                                        setIsSaveEnabled(true);
                                    }}
                                    disabled={isDisableds}
                                    onBlur={validation.handleBlur}
                                    value={validation.values.other_fee || ""}
                                    invalid={ validation.touched.other_fee && validation.errors.other_fee ? true : false }
                                />
                                { validation.touched.other_fee && validation.errors.other_fee ? ( 
                                    <FormFeedback type="invalid" style={{display: "block"}}>
                                        {validation.errors.other_fee}
                                    </FormFeedback> 
                                ) : false }
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={10}>
                            <FormGroup>
                                <Label className="label-title">ข้อตกลงพิเศษหรือเงื่อนไขอื่น ๆ (หากมี) (Other Special clause or Conditions)</Label>
                                <Input id="txtOtherSpecialClause"
                                    name="other_special_clause"
                                    placeholder="ระบุเงื่อนไขอื่นๆ หากมี"
                                    type="text"
                                    className="from-control txt-placeholder"
                                    onChange={(e) => {
                                        validation.handleChange(e);
                                        validationDraft.handleChange(e);
                                        setIsSaveEnabled(true);
                                    }}
                                    disabled={isDisableds}
                                    onBlur={validation.handleBlur}
                                    value={validation.values.other_special_clause || ""}
                                    invalid={ validation.touched.other_special_clause && validation.errors.other_special_clause ? true : false }
                                />
                                { validation.touched.other_special_clause && validation.errors.other_special_clause ? ( 
                                    <FormFeedback type="invalid" style={{display: "block"}}>
                                        {validation.errors.other_special_clause}
                                    </FormFeedback> 
                                ) : false }
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={3}>
                            <FormGroup>
                                <Label className="label-title">ภาษา (Language)<span className="msg-require">*</span></Label>
                                <i className="mdi mdi-help-circle icon-hint-right" id="prIdLanguage"></i>
                                <div className="hstack flex-wrap gap-2">
                                    <UncontrolledPopover placement="right" target="prIdLanguage">
                                        <PopoverBody className="msg-show-hint"><i className="mdi mdi-help-circle msg-icon-hint"></i> เลือกได้เพียง 1 ภาษา หากมากกว่า 1 ภาษา User ต้องทำการแปลเอง<br/>Available in a single language; users are responsible for translation if a bilingual document is needed.</PopoverBody>
                                    </UncontrolledPopover>
                                </div>
                                <Select id="ddlLanguage"
                                    name="id_language"
                                    value={selectLanguage}
                                    className="txt-placeholder"
                                    placeholder="เลือกภาษา"
                                    onChange={(selected) => {
                                        setSelectLanguage(selected);
                                        validation.handleChange("id_language")((selected !== null) ? selected.value : "");
                                        validationDraft.handleChange("id_language")((selected !== null) ? selected.value : "");
                                        setIsSaveEnabled(true);
                                    }}
                                    isDisabled={isDisableds}
                                    options={ddlLanguage}
                                    isClearable={true}
                                    isSearchable={true}
                                    invalid={ validation.touched.id_language && validation.errors.id_language ? true : false }
                                />
                                { validation.touched.id_language && validation.errors.id_language ? ( 
                                    <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">
                                        {validation.errors.id_language}
                                    </FormFeedback> 
                                ) : false }
                            </FormGroup>
                        </Col>
                        <Col md={7}>
                            <FormGroup>
                                <Label className="label-title-confidential">ระดับชั้นความลับ (Confidentiality Level)<span className="msg-require">*</span></Label>
                                <i className="mdi mdi-help-circle icon-hint-right" id="prIdConfidentialLevel"></i>
                                <div className="hstack flex-wrap gap-2">
                                    <UncontrolledPopover placement="top" target="prIdConfidentialLevel">
                                        <PopoverBody className="msg-show-hint"><i className="mdi mdi-help-circle msg-icon-hint"></i> "ทั่วไป" หมายถึง สามารถเปิดเผยให้ฝ่ายกฎหมายและผู้ที่เกี่ยวข้องได้ <br/>"เป็นความลับ" หมายถึง เอกสารนี้จะเปิดเผยให้แก่ฝ่ายกฎหมายที่ถูกระบุชื่อ และฝ่ายกฎหมายระดับ Associate Director ขึ้นไปเท่านั้น​<br/>"General" means that this request will be shared with all legal team members and related persons. ​<br/> "Confidential" means that this request will be shared with the specified legal person and legal associate directors or higher level.</PopoverBody>
                                    </UncontrolledPopover>
                                </div>
                                
                                <Select id="ddlConfidential"
                                    name="id_confidential_level"
                                    value={selectConfidential}
                                    className="txt-placeholder"
                                    placeholder="เลือกระดับความลับของเอกสาร"
                                    onChange={(selected) => {
                                        setSelectConfidential(selected);
                                        validation.handleChange("id_confidential_level")((selected !== null) ? selected.value : "");
                                        validationDraft.handleChange("id_confidential_level")((selected !== null) ? selected.value : "");
                                        setIsSaveEnabled(true);
                                    }}
                                    options={ddlConfidential}
                                    isClearable={true}
                                    isSearchable={true}
                                    isDisabled={isDisableds}
                                    invalid={ validation.touched.id_confidential_level && validation.errors.id_confidential_level ? true : false }
                                />
                                { validation.touched.id_confidential_level && validation.errors.id_confidential_level ? ( 
                                    <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">
                                        {validation.errors.id_confidential_level}
                                    </FormFeedback> 
                                ) : false }
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={10}>
                            <FormGroup>
                                <Label className="label-title">
                                    มีการเปิดเผย/ใช้/ประมวลผลข้อมูลส่วนบุคคลภายใต้เอกสารนี้หรือไม่ 
                                    <br />
                                    (Personal data will be disclosed/used/processed under this document)
                                    <span className="msg-require">*</span>
                                </Label>
                                <i className="mdi mdi-help-circle icon-hint-right" id="prPdpa"></i>
                                <div className="hstack flex-wrap gap-2">
                                    <UncontrolledPopover placement="top" target="prPdpa">
                                        <PopoverBody className="msg-show-hint"><i className="mdi mdi-help-circle msg-icon-hint"></i> ข้อมูลส่วนบุคคลคือข้อมูลที่สามารถระบุตัวบุคคลใดได้ไม่ว่าทางตรงหรือทางอ้อม<br/>Personal Information is any information relating to a person, which enables the identification of such person, whether directly or indirectly.</PopoverBody>
                                    </UncontrolledPopover>
                                </div>
                                <div className="form-check form-check-inline ms-3 mt-3">
                                    <Input id="cbPdpaYes"
                                        name="share_pdpa"
                                        className="form-check-input"
                                        type="radio"
                                        checked={sharePdpa === "1"}
                                        onChange={() => {
                                            setSharePdpa("1");
                                            validation.handleChange('share_pdpa')("1");
                                            validationDraft.handleChange('share_pdpa')("1");
                                            setIsSaveEnabled(true);
                                        }}
                                        disabled={isDisableds}
                                    />
                                    <Label className="form-check-label-2row" htmlFor="cbPdpaYes">
                                        Yes (This request will be shared with PDPA team)
                                    </Label>
                                </div>
                                <div className="form-check form-check-inline ms-3 mt-3">
                                    <Input id="cbPdpaNo"
                                        name="share_pdpa"
                                        className="form-check-input"
                                        type="radio"
                                        checked={sharePdpa === "0"}
                                        onChange={() => {
                                            setSharePdpa("0");
                                            validation.handleChange('share_pdpa')("0");
                                            validationDraft.handleChange('share_pdpa')("0");
                                            setIsSaveEnabled(true);
                                        }}
                                        disabled={isDisableds}
                                    />
                                    <Label className="form-check-label-2row" htmlFor="cbPdpaNo">
                                        No
                                    </Label>
                                </div>
                                { validation.touched.share_pdpa && validation.errors.share_pdpa ? ( 
                                    <FormFeedback type="invalid" style={{display: "block"}}>
                                        {validation.errors.share_pdpa}
                                    </FormFeedback> 
                                ) : false }
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={10}>
                            <FormGroup>
                                <Label className="label-title">ความเห็นของ User (User's Comment)<span className="msg-require">*</span></Label>
                                <i className="mdi mdi-help-circle icon-hint-right" id="prUserComment"></i>
                                <div className="hstack flex-wrap gap-2">
                                    <UncontrolledPopover placement="right" target="prUserComment" >
                                        <PopoverBody className="msg-show-hint"><i className="mdi mdi-help-circle msg-icon-hint"></i> กรุณาระบุว่าจากการตรวจสอบของ User แล้ว User มีความเห็นเพิ่มเติมในเอกสาร/สัญญาดังกล่าวอย่างไรบ้าง<br/>Please specify if the user has any comments on the documents / agreements.​</PopoverBody>
                                    </UncontrolledPopover>
                                </div>
                                <Input id="txtUserComment"
                                    name="user_comment"
                                    placeholder="ระบุว่ามีความเห็นเพิ่มเติมในเอกสาร/สัญญาดังกล่าวอย่างไร"
                                    type="text"
                                    className="from-control txt-placeholder"
                                    onChange={(e) => {
                                        validation.handleChange(e);
                                        validationDraft.handleChange(e);
                                        setIsSaveEnabled(true);
                                    }}
                                    onBlur={validation.handleBlur}
                                    value={validation.values.user_comment || ""}
                                    invalid={ validation.touched.user_comment && validation.errors.user_comment ? true : false }
                                    disabled={isDisableds}
                                />
                                { validation.touched.user_comment && validation.errors.user_comment ? ( 
                                    <FormFeedback type="invalid" style={{display: "block"}}>
                                        {validation.errors.user_comment}
                                    </FormFeedback> 
                                ) : false }
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={10}>
                            <FormGroup>
                                <Label className="label-title">ระบุอีเมลของนักกฎหมายที่เคยรับผิดชอบเอกสารนี้ (Legal team who has handled this work (if any))</Label>
                                <i className="mdi mdi-help-circle icon-hint-right" id="prRequestHandledBy"></i>
                                <div className="hstack flex-wrap gap-2">
                                    <UncontrolledPopover placement="top" target="prRequestHandledBy">
                                        <PopoverBody className="msg-show-hint"><i className="mdi mdi-help-circle msg-icon-hint"></i> ระบุอีเมลของนักกฎหมายที่เคยรับผิดชอบเอกสารนี้ (ขั้นตอนนี้ไม่ใช่การกำหนดเลือกคนทำงาน ฝ่ายกฎหมายขอสงวนสิทธิ์ในการกำหนดคนทำงานนี้ต่อไป)<br/>This request will be sent to the e-mail address of the e-mail person. (This step is not to select workers. The Legal Department reserves the right to solely decide and assign people to do this work.)</PopoverBody>
                                    </UncontrolledPopover>
                                </div>
                                <Input id="txtRequestHandledBy" 
                                    name="require_handled_by"
                                    className="txt-placeholder"
                                    placeholder="กรุณาระบุอีเมลของนักกฎหมายที่เคยรับผิดชอบเอกสารนี้"
                                    onChange={(e) => {
                                        validation.handleChange(e);
                                        validationDraft.handleChange(e);
                                        setIsSaveEnabled(true);
                                    }}
                                    onBlur={validation.handleBlur}
                                    value={validation.values.require_handled_by || ""}
                                    invalid={validation.touched.require_handled_by && validation.errors.require_handled_by ? true : false}
                                    disabled={isDisableds}
                                />
                                {validation.touched.require_handled_by && validation.errors.require_handled_by ? (
                                    <FormFeedback type="invalid" style={{ display: "block" }} className="msg-show-hint">
                                        {validation.errors.require_handled_by}
                                    </FormFeedback>
                                ) : false}
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12}>
                            <div className="line-border"></div>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12} className="mb-2">
                            <span className="span-title">
                                User Approval Process
                            </span>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={10}>
                            <FormGroup>
                            <Label className="label-title">ผู้อนุมัติแบบคำขอ (User Approver)<span className="msg-require">*</span></Label>
                                <i className="mdi mdi-help-circle icon-hint-right" id="PopoverRightApproval"></i>
                                <div className="hstack flex-wrap gap-2">
                                    <UncontrolledPopover placement="right" target="PopoverRightApproval" >
                                        <PopoverBody className="msg-show-hint"><i className="mdi mdi-help-circle msg-icon-hint"></i> โปรดระบุชื่อผู้อนุมัติคำขอ โดยคำขอทุกฉบับต้องได้รับการอนุมัติจากผู้มีตำแหน่ง Director ขึ้นไปในฝ่ายผู้ขอ <br/>(Please specify the approver's name. Kindly note that all requests must be approved by director or higher level in your function.)​</PopoverBody>
                                    </UncontrolledPopover>
                                </div>
                                <Input id="txtApproveRequestBy"
                                    name="approve_request_by"
                                    type="text"
                                    className="txt-placeholder"
                                    placeholder="กรุณากรอกอีเมล"
                                    onChange={(e) => {
                                        validation.handleChange(e);
                                        validationDraft.handleChange(e);
                                        setIsSaveEnabled(true);
                                    }}
                                    onBlur={validation.handleBlur}
                                    value={validation.values.approve_request_by || ""}
                                    invalid={validation.touched.approve_request_by && validation.errors.approve_request_by ? true : false}
                                    disabled={isDisableds}
                                />
                                {validation.touched.approve_request_by && validation.errors.approve_request_by ? (
                                    <FormFeedback type="invalid" style={{ display: "block" }}>
                                        {validation.errors.approve_request_by}
                                    </FormFeedback>
                                ) : false}
                            </FormGroup>
                        </Col>
                    </Row>
                     { checkShowInputUserCoordinator ? (
                        <Col md={10}>
                            <FormGroup>
                            <i className="mdi mdi-help-circle icon-hint-right" id="PopoverRightCoodinator"></i>
                            <div className="hstack flex-wrap gap-2">
                                <UncontrolledPopover placement="right" target="PopoverRightCoodinator">
                                    <PopoverBody className="msg-show-hint"><i className="mdi mdi-help-circle msg-icon-hint"></i> โปรดระบุอีเมลของผู้ประสานงานสำหรับคำขอนี้โดยจะต้องเป็นผู้ที่มีรายชื่อเป็นผู้ประสานงานตามที่บริษัทกำหนดและได้แจ้งฝ่ายกฎหมาย BTSG ไว้แล้ว <br/>Please specify the email address of the coordinator for this request. The specified person must be listed as a coordinator as designated by the company and has been informed to BTSG legal team.</PopoverBody>
                                </UncontrolledPopover>
                            </div>
                            <Label className="label-title">ชื่อผู้ประสานงาน (Name of User Coordinator)<span className="msg-require">*</span></Label>
                            <Input
                                type="text"
                                id="txtCreateRequestBy"
                                name="create_request_by"
                                autoComplete={autoCompletes}
                                className="txt-placeholder"
                                placeholder="กรอกอีเมลผู้ประสานงาน"
                                onChange={(e) => {
                                    validation.handleChange(e);
                                    validationDraft.handleChange(e);
                                    // console.log(e.target.value);
                                    setIsSaveEnabled(true); // Set save enabled to true when the input changes
                                }}
                                onBlur={validation.handleBlur}
                                value={validation.values.create_request_by || ""}
                                invalid={validation.touched.create_request_by && validation.errors.create_request_by ? true : false}
                                disabled={isDisableds || dataFormRequest.request_no !== "draft" && dataUser.email === dataFormRequest.create_request_by || dataFormRequest.id_workflow_status > 4 ? true : false}
                            />
                                {validation.touched.create_request_by && validation.errors.create_request_by ? (
                                <FormFeedback type="invalid" style={{ display: "block" }} className="msg-show-hint">
                                    {validation.errors.create_request_by}
                                </FormFeedback>
                                ) : false}
                            
                            </FormGroup>
                        </Col>
                        ):""}
                        { showCommentApprover === true || dataFormGct.approver_comment !== "" ?(
                            <>
                            <Col md={12}>
                                <div className="line-border"></div>
                            </Col>
                            <Col md={10}>
                                <div className="page-content-approver">
                                    <div className="approver-header-content">
                                    {dataUser.email === dataFormRequest.approve_request_by ? "ระบุความเห็นเพื่อส่งไปยังผู้ร้องขอ (Please specify comments to send to the requester.)" : "คุณมีความเห็นจากผู้อนุมัติ (You have a comments from the approver)"}
                                    </div>
                                    <FormGroup>
                                    <Col md={10} className="approver-col">
                                        <Label className="label-title-approver-comment">ความเห็นของผู้อนุมัติ (Approver's Comment)</Label>
                                        <Input
                                            type="text"
                                            id="txtApproveComment"
                                            name="approver_comment"
                                            autoComplete={autoCompletes}
                                            className="txt-approver-comment"
                                            placeholder="ความเห็นเพิ่มเติมของผู้อนุมัติ"
                                            onChange={(e) => {
                                                validation.handleChange(e);
                                                validationDraft.handleChange(e);
                                                validationReturn.handleChange(e);
                                                //setIsSaveEnabled(true); // Set save enabled to true when the input changes
                                            }}
                                            onBlur={validationReturn.handleBlur}
                                            value={validation.values.approver_comment || ""}
                                            invalid={validationReturn.touched.approver_comment && validationReturn.errors.approver_comment ? true : false}
                                            disabled={(dataUser.email === dataFormRequest.request_by) || (dataUser.email === dataFormRequest.approve_request_by && dataFormRequest.id_workflow_status === 4) ? true : false}
                                        />
                                        {validationReturn.touched.approver_comment && validationReturn.errors.approver_comment ? (
                                        <FormFeedback type="invalid" className="alert-validation-approver-comment">
                                            {validationReturn.errors.approver_comment}
                                        </FormFeedback>
                                        ) : false}
                                    </Col>
                                    </FormGroup>
                                </div>
                            </Col>
                            <Col md={12}>
                                <div className="line-border"></div>
                            </Col>
                            </>
                        ):null}
                    <Row>
                        <Col md={10}>
                            <Alert className="border-0 border-0 remark-content">
                                <i className="mdi mdi-alert icon-remark-color"></i><strong className="remark-color"> หมายเหตุ (Remark) </strong><br/>
                                <span className="span-remark">"User รับทราบว่าแบบฟอร์มนี้เป็นความลับและมีวัตถุประสงค์เพื่อใช้ภายในบริษัทในเครือ BTS Group เท่านั้น หากพนักงานเปิดเผยข้อมูลแบบฟอร์มให้แก่บุคคลภายนอก ถือว่าประพฤติผิดวินัยอย่างร้ายแรง"</span><br/>
                                <span className="span-remark">"Users are fully aware that this request form is strictly private and confidential for internal use within BTS Group's affiliates only. Any employee disclosing this request form to the third party is considered a serious misconduct."</span>
                            </Alert>
                        </Col>
                    </Row>
                </div>
                    {   
                        dataFormRequest.id_workflow_status >= 0 && // Check if status is 0 or greater
                        dataFormRequest.id_workflow_status <= 4 ||
                        dataFormGct.id === 0 ? (
                        <Row>
                            <div className="page-footer">
                                <div className="layout-width-footer">
                                    <div className="navbar-footer">
                                        <>
                                        <div className="d-flex align-items-center">
                                            <Link to={GetUrlBack()} className="logo">
                                                <Button 
                                                    color="outline secondary" 
                                                    type="button" 
                                                    // onClick={handleBack}
                                                >
                                                Back
                                                </Button>
                                            </Link>
                                        </div>
                                        <div className="d-flex align-items-center">
                                            {dataFormRequest.request_no === "draft" ? (
                                                <Button 
                                                    color="outline secondary" 
                                                    type="button" 
                                                    // onClick={handleBack}
                                                    onClick={() => onCancelRequest(dataFormRequest)}
                                                >
                                                Delete
                                                </Button>
                                            ): null}
                                            {checkUserIsApproverShowReturnBtn ?(
                                                <>
                                                {/* case if requestor && approver ถ้าคนเปิด request และ คนอนุมัติเป็นคนเดียวกันจะปิด ปุ่ม return  */}
                                                {checkUserCreateTicketAndApproveIsSame ?(
                                                <Button 
                                                className="btn-return-style"
                                                color="outline secondary" 
                                                type="button" 
                                                disabled={isSaveEnabled}
                                                onClick={() => onCheckReturn()}
                                                >
                                                    Return
                                                </Button>
                                                ):null}
                                                </>
                                            ):null}
                                            {changeButtonIsStateRequestorOrApprover ?(
                                                <>
                                                <Button 
                                                    className="float-end btn-save-style"  
                                                    color={isSaveEnabled ? "primary" : "secondary"} 
                                                    outline 
                                                    type="button" 
                                                    disabled={!isSaveEnabled}
                                                    onClick={() => onCheckSaveDraft()}
                                                >
                                                    Save
                                                </Button>
                                                <Button 
                                                    className="float-end btn-submit-style" 
                                                    color="primary" 
                                                    type="button"
                                                    disabled={dataUser.email === dataFormRequest.approve_request_by ? isSaveEnabled : false}
                                                    // onClick={handleNext}
                                                    // onClick={() => onClickSubmit(1)}
                                                    // onClick={() => setIsShowModal(true)}
                                                    onClick={() => { onCheckSubmit()}}
                                                >
                                                    {/* {userEmail +"/"+ dataFormRequest.request_by} */}
                                                {dataUser.email === dataFormRequest.approve_request_by ? "Approve" : "Submit"}
                                                </Button>
                                                </>
                                            ):null}
                                        </div>
                                        </>
                                    </div>
                                </div>
                            </div>
                        </Row>
                        ):
                        <>
                            <div id="footer-modal" className="footer-modal-memo">
                                <hr className="line-footer"></hr>
                                <Col md={12}>
                                    <Button 
                                        className="float-end btn-submit-style" 
                                        color="primary" 
                                        type="button"
                                        onClick={() => validation.submitForm()}
                                    >
                                        Update
                                    </Button>
                                    <Button 
                                        className="float-end btn-cancel" 
                                        color="outline secondary" 
                                        type="button" 
                                        onClick={() => onCancelRequest(false)}
                                    >
                                        Cancel
                                    </Button>
                                </Col>
                            </div>
                        </>
                    }
                </Form>
            </div>
        </React.Fragment>
    );
};

export default RequestFormGct;